var Od = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function qd(e) {
  return e;
}
function we(e, t, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return l(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function A(e, t, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return l(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var u = arguments[0], h = 1; h < arguments.length; h++)
        u = arguments[h](u);
      return u;
    }
  }
}
var Pd = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, Od([a], n, !1));
    };
  };
}, Vd = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Md = function(e) {
  return Vd(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, Fc = function(e) {
  return e._tag === "Some";
}, Zc = { _tag: "None" }, Wc = function(e) {
  return { _tag: "Some", value: e };
}, Nd = function(e) {
  return e._tag === "Left";
}, $d = function(e) {
  return e._tag === "Right";
}, Dd = function(e) {
  return { _tag: "Left", left: e };
}, Hd = function(e) {
  return { _tag: "Right", right: e };
}, jd = function(e) {
  return [e];
}, Ld = [], Ud = Object.prototype.hasOwnProperty, Kd = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, Bd = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        Ud.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, Pr = function() {
  return { concat: qd };
}, Gd = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, Fd = Kd, ai = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Zd = Ld, Wd = function(e, t) {
  return e < 0 || e >= t.length;
}, Jd = function(e) {
  return function(t) {
    return ai(ai([], t, !0), [e], !1);
  };
}, zd = Jd, Qd = jd, ve = {
  equals: function(e, t) {
    return e === t;
  }
}, Yd = {
  concat: function(e, t) {
    return e + t;
  }
}, Xd = "", us = {
  concat: Yd.concat,
  empty: Xd
};
ve.equals;
var Jc = function(e) {
  return e.trim();
}, zc = function(e) {
  return e.length === 0;
}, Bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Qc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vr, si;
function ef() {
  if (si) return Vr;
  si = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Vr = e, Vr;
}
var Mr, ii;
function ls() {
  if (ii) return Mr;
  ii = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Mr = e, Mr;
}
var Nr, oi;
function or() {
  if (oi) return Nr;
  oi = 1;
  var e = ls();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Nr = t, Nr;
}
var $r, ci;
function tf() {
  if (ci) return $r;
  ci = 1;
  var e = or(), t = Array.prototype, r = t.splice;
  function n(a) {
    var s = this.__data__, i = e(s, a);
    if (i < 0)
      return !1;
    var o = s.length - 1;
    return i == o ? s.pop() : r.call(s, i, 1), --this.size, !0;
  }
  return $r = n, $r;
}
var Dr, ui;
function rf() {
  if (ui) return Dr;
  ui = 1;
  var e = or();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Dr = t, Dr;
}
var Hr, li;
function nf() {
  if (li) return Hr;
  li = 1;
  var e = or();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Hr = t, Hr;
}
var jr, di;
function af() {
  if (di) return jr;
  di = 1;
  var e = or();
  function t(r, n) {
    var a = this.__data__, s = e(a, r);
    return s < 0 ? (++this.size, a.push([r, n])) : a[s][1] = n, this;
  }
  return jr = t, jr;
}
var Lr, fi;
function cr() {
  if (fi) return Lr;
  fi = 1;
  var e = ef(), t = tf(), r = rf(), n = nf(), a = af();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var u = i[o];
      this.set(u[0], u[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Lr = s, Lr;
}
var Ur, hi;
function sf() {
  if (hi) return Ur;
  hi = 1;
  var e = cr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ur = t, Ur;
}
var Kr, pi;
function of() {
  if (pi) return Kr;
  pi = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Kr = e, Kr;
}
var Br, yi;
function cf() {
  if (yi) return Br;
  yi = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Br = e, Br;
}
var Gr, mi;
function uf() {
  if (mi) return Gr;
  mi = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Gr = e, Gr;
}
var Fr, vi;
function Yc() {
  if (vi) return Fr;
  vi = 1;
  var e = typeof Bt == "object" && Bt && Bt.Object === Object && Bt;
  return Fr = e, Fr;
}
var Zr, gi;
function fe() {
  if (gi) return Zr;
  gi = 1;
  var e = Yc(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Zr = r, Zr;
}
var Wr, _i;
function ur() {
  if (_i) return Wr;
  _i = 1;
  var e = fe(), t = e.Symbol;
  return Wr = t, Wr;
}
var Jr, bi;
function lf() {
  if (bi) return Jr;
  bi = 1;
  var e = ur(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function s(i) {
    var o = r.call(i, a), l = i[a];
    try {
      i[a] = void 0;
      var u = !0;
    } catch {
    }
    var h = n.call(i);
    return u && (o ? i[a] = l : delete i[a]), h;
  }
  return Jr = s, Jr;
}
var zr, Si;
function df() {
  if (Si) return zr;
  Si = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return zr = r, zr;
}
var Qr, Ai;
function lr() {
  if (Ai) return Qr;
  Ai = 1;
  var e = ur(), t = lf(), r = df(), n = "[object Null]", a = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function i(o) {
    return o == null ? o === void 0 ? a : n : s && s in Object(o) ? t(o) : r(o);
  }
  return Qr = i, Qr;
}
var Yr, Ti;
function kt() {
  if (Ti) return Yr;
  Ti = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Yr = e, Yr;
}
var Xr, Ei;
function Xc() {
  if (Ei) return Xr;
  Ei = 1;
  var e = lr(), t = kt(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", s = "[object Proxy]";
  function i(o) {
    if (!t(o))
      return !1;
    var l = e(o);
    return l == n || l == a || l == r || l == s;
  }
  return Xr = i, Xr;
}
var en, Ri;
function ff() {
  if (Ri) return en;
  Ri = 1;
  var e = fe(), t = e["__core-js_shared__"];
  return en = t, en;
}
var tn, wi;
function hf() {
  if (wi) return tn;
  wi = 1;
  var e = ff(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return tn = r, tn;
}
var rn, Ci;
function eu() {
  if (Ci) return rn;
  Ci = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return rn = r, rn;
}
var nn, Ii;
function pf() {
  if (Ii) return nn;
  Ii = 1;
  var e = Xc(), t = hf(), r = kt(), n = eu(), a = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, i = Function.prototype, o = Object.prototype, l = i.toString, u = o.hasOwnProperty, h = RegExp(
    "^" + l.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(S) {
    if (!r(S) || t(S))
      return !1;
    var P = e(S) ? h : s;
    return P.test(n(S));
  }
  return nn = m, nn;
}
var an, xi;
function yf() {
  if (xi) return an;
  xi = 1;
  function e(t, r) {
    return t?.[r];
  }
  return an = e, an;
}
var sn, ki;
function Fe() {
  if (ki) return sn;
  ki = 1;
  var e = pf(), t = yf();
  function r(n, a) {
    var s = t(n, a);
    return e(s) ? s : void 0;
  }
  return sn = r, sn;
}
var on, Oi;
function ds() {
  if (Oi) return on;
  Oi = 1;
  var e = Fe(), t = fe(), r = e(t, "Map");
  return on = r, on;
}
var cn, qi;
function dr() {
  if (qi) return cn;
  qi = 1;
  var e = Fe(), t = e(Object, "create");
  return cn = t, cn;
}
var un, Pi;
function mf() {
  if (Pi) return un;
  Pi = 1;
  var e = dr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return un = t, un;
}
var ln, Vi;
function vf() {
  if (Vi) return ln;
  Vi = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return ln = e, ln;
}
var dn, Mi;
function gf() {
  if (Mi) return dn;
  Mi = 1;
  var e = dr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    var i = this.__data__;
    if (e) {
      var o = i[s];
      return o === t ? void 0 : o;
    }
    return n.call(i, s) ? i[s] : void 0;
  }
  return dn = a, dn;
}
var fn, Ni;
function _f() {
  if (Ni) return fn;
  Ni = 1;
  var e = dr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var s = this.__data__;
    return e ? s[a] !== void 0 : r.call(s, a);
  }
  return fn = n, fn;
}
var hn, $i;
function bf() {
  if ($i) return hn;
  $i = 1;
  var e = dr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = e && a === void 0 ? t : a, this;
  }
  return hn = r, hn;
}
var pn, Di;
function Sf() {
  if (Di) return pn;
  Di = 1;
  var e = mf(), t = vf(), r = gf(), n = _f(), a = bf();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var u = i[o];
      this.set(u[0], u[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, pn = s, pn;
}
var yn, Hi;
function Af() {
  if (Hi) return yn;
  Hi = 1;
  var e = Sf(), t = cr(), r = ds();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return yn = n, yn;
}
var mn, ji;
function Tf() {
  if (ji) return mn;
  ji = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return mn = e, mn;
}
var vn, Li;
function fr() {
  if (Li) return vn;
  Li = 1;
  var e = Tf();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return vn = t, vn;
}
var gn, Ui;
function Ef() {
  if (Ui) return gn;
  Ui = 1;
  var e = fr();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return gn = t, gn;
}
var _n, Ki;
function Rf() {
  if (Ki) return _n;
  Ki = 1;
  var e = fr();
  function t(r) {
    return e(this, r).get(r);
  }
  return _n = t, _n;
}
var bn, Bi;
function wf() {
  if (Bi) return bn;
  Bi = 1;
  var e = fr();
  function t(r) {
    return e(this, r).has(r);
  }
  return bn = t, bn;
}
var Sn, Gi;
function Cf() {
  if (Gi) return Sn;
  Gi = 1;
  var e = fr();
  function t(r, n) {
    var a = e(this, r), s = a.size;
    return a.set(r, n), this.size += a.size == s ? 0 : 1, this;
  }
  return Sn = t, Sn;
}
var An, Fi;
function tu() {
  if (Fi) return An;
  Fi = 1;
  var e = Af(), t = Ef(), r = Rf(), n = wf(), a = Cf();
  function s(i) {
    var o = -1, l = i == null ? 0 : i.length;
    for (this.clear(); ++o < l; ) {
      var u = i[o];
      this.set(u[0], u[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, An = s, An;
}
var Tn, Zi;
function If() {
  if (Zi) return Tn;
  Zi = 1;
  var e = cr(), t = ds(), r = tu(), n = 200;
  function a(s, i) {
    var o = this.__data__;
    if (o instanceof e) {
      var l = o.__data__;
      if (!t || l.length < n - 1)
        return l.push([s, i]), this.size = ++o.size, this;
      o = this.__data__ = new r(l);
    }
    return o.set(s, i), this.size = o.size, this;
  }
  return Tn = a, Tn;
}
var En, Wi;
function ru() {
  if (Wi) return En;
  Wi = 1;
  var e = cr(), t = sf(), r = of(), n = cf(), a = uf(), s = If();
  function i(o) {
    var l = this.__data__ = new e(o);
    this.size = l.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = s, En = i, En;
}
var Rn, Ji;
function xf() {
  if (Ji) return Rn;
  Ji = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return Rn = e, Rn;
}
var wn, zi;
function kf() {
  if (zi) return wn;
  zi = 1;
  var e = Fe(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return wn = t, wn;
}
var Cn, Qi;
function nu() {
  if (Qi) return Cn;
  Qi = 1;
  var e = kf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return Cn = t, Cn;
}
var In, Yi;
function au() {
  if (Yi) return In;
  Yi = 1;
  var e = nu(), t = ls(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o) {
    var l = s[i];
    (!(n.call(s, i) && t(l, o)) || o === void 0 && !(i in s)) && e(s, i, o);
  }
  return In = a, In;
}
var xn, Xi;
function hr() {
  if (Xi) return xn;
  Xi = 1;
  var e = au(), t = nu();
  function r(n, a, s, i) {
    var o = !s;
    s || (s = {});
    for (var l = -1, u = a.length; ++l < u; ) {
      var h = a[l], m = i ? i(s[h], n[h], h, s, n) : void 0;
      m === void 0 && (m = n[h]), o ? t(s, h, m) : e(s, h, m);
    }
    return s;
  }
  return xn = r, xn;
}
var kn, eo;
function Of() {
  if (eo) return kn;
  eo = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return kn = e, kn;
}
var On, to;
function mt() {
  if (to) return On;
  to = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return On = e, On;
}
var qn, ro;
function qf() {
  if (ro) return qn;
  ro = 1;
  var e = lr(), t = mt(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return qn = n, qn;
}
var Pn, no;
function Pf() {
  if (no) return Pn;
  no = 1;
  var e = qf(), t = mt(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, s = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return Pn = s, Pn;
}
var Vn, ao;
function pr() {
  if (ao) return Vn;
  ao = 1;
  var e = Array.isArray;
  return Vn = e, Vn;
}
var bt = { exports: {} }, Mn, so;
function Vf() {
  if (so) return Mn;
  so = 1;
  function e() {
    return !1;
  }
  return Mn = e, Mn;
}
bt.exports;
var io;
function fs() {
  return io || (io = 1, (function(e, t) {
    var r = fe(), n = Vf(), a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, l = o ? o.isBuffer : void 0, u = l || n;
    e.exports = u;
  })(bt, bt.exports)), bt.exports;
}
var Nn, oo;
function Mf() {
  if (oo) return Nn;
  oo = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var s = typeof n;
    return a = a ?? e, !!a && (s == "number" || s != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Nn = r, Nn;
}
var $n, co;
function su() {
  if (co) return $n;
  co = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return $n = t, $n;
}
var Dn, uo;
function Nf() {
  if (uo) return Dn;
  uo = 1;
  var e = lr(), t = su(), r = mt(), n = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", i = "[object Date]", o = "[object Error]", l = "[object Function]", u = "[object Map]", h = "[object Number]", m = "[object Object]", S = "[object RegExp]", P = "[object Set]", N = "[object String]", V = "[object WeakMap]", D = "[object ArrayBuffer]", $ = "[object DataView]", C = "[object Float32Array]", B = "[object Float64Array]", O = "[object Int8Array]", G = "[object Int16Array]", q = "[object Int32Array]", x = "[object Uint8Array]", W = "[object Uint8ClampedArray]", j = "[object Uint16Array]", re = "[object Uint32Array]", I = {};
  I[C] = I[B] = I[O] = I[G] = I[q] = I[x] = I[W] = I[j] = I[re] = !0, I[n] = I[a] = I[D] = I[s] = I[$] = I[i] = I[o] = I[l] = I[u] = I[h] = I[m] = I[S] = I[P] = I[N] = I[V] = !1;
  function X(se) {
    return r(se) && t(se.length) && !!I[e(se)];
  }
  return Dn = X, Dn;
}
var Hn, lo;
function hs() {
  if (lo) return Hn;
  lo = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Hn = e, Hn;
}
var St = { exports: {} };
St.exports;
var fo;
function ps() {
  return fo || (fo = 1, (function(e, t) {
    var r = Yc(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = (function() {
      try {
        var l = a && a.require && a.require("util").types;
        return l || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = o;
  })(St, St.exports)), St.exports;
}
var jn, ho;
function iu() {
  if (ho) return jn;
  ho = 1;
  var e = Nf(), t = hs(), r = ps(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return jn = a, jn;
}
var Ln, po;
function ou() {
  if (po) return Ln;
  po = 1;
  var e = Of(), t = Pf(), r = pr(), n = fs(), a = Mf(), s = iu(), i = Object.prototype, o = i.hasOwnProperty;
  function l(u, h) {
    var m = r(u), S = !m && t(u), P = !m && !S && n(u), N = !m && !S && !P && s(u), V = m || S || P || N, D = V ? e(u.length, String) : [], $ = D.length;
    for (var C in u)
      (h || o.call(u, C)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      P && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      N && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      a(C, $))) && D.push(C);
    return D;
  }
  return Ln = l, Ln;
}
var Un, yo;
function ys() {
  if (yo) return Un;
  yo = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return Un = t, Un;
}
var Kn, mo;
function cu() {
  if (mo) return Kn;
  mo = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Kn = e, Kn;
}
var Bn, vo;
function $f() {
  if (vo) return Bn;
  vo = 1;
  var e = cu(), t = e(Object.keys, Object);
  return Bn = t, Bn;
}
var Gn, go;
function Df() {
  if (go) return Gn;
  go = 1;
  var e = ys(), t = $f(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    if (!e(s))
      return t(s);
    var i = [];
    for (var o in Object(s))
      n.call(s, o) && o != "constructor" && i.push(o);
    return i;
  }
  return Gn = a, Gn;
}
var Fn, _o;
function uu() {
  if (_o) return Fn;
  _o = 1;
  var e = Xc(), t = su();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return Fn = r, Fn;
}
var Zn, bo;
function ms() {
  if (bo) return Zn;
  bo = 1;
  var e = ou(), t = Df(), r = uu();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return Zn = n, Zn;
}
var Wn, So;
function Hf() {
  if (So) return Wn;
  So = 1;
  var e = hr(), t = ms();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return Wn = r, Wn;
}
var Jn, Ao;
function jf() {
  if (Ao) return Jn;
  Ao = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return Jn = e, Jn;
}
var zn, To;
function Lf() {
  if (To) return zn;
  To = 1;
  var e = kt(), t = ys(), r = jf(), n = Object.prototype, a = n.hasOwnProperty;
  function s(i) {
    if (!e(i))
      return r(i);
    var o = t(i), l = [];
    for (var u in i)
      u == "constructor" && (o || !a.call(i, u)) || l.push(u);
    return l;
  }
  return zn = s, zn;
}
var Qn, Eo;
function vs() {
  if (Eo) return Qn;
  Eo = 1;
  var e = ou(), t = Lf(), r = uu();
  function n(a) {
    return r(a) ? e(a, !0) : t(a);
  }
  return Qn = n, Qn;
}
var Yn, Ro;
function Uf() {
  if (Ro) return Yn;
  Ro = 1;
  var e = hr(), t = vs();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return Yn = r, Yn;
}
var At = { exports: {} };
At.exports;
var wo;
function Kf() {
  return wo || (wo = 1, (function(e, t) {
    var r = fe(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
    function l(u, h) {
      if (h)
        return u.slice();
      var m = u.length, S = o ? o(m) : new u.constructor(m);
      return u.copy(S), S;
    }
    e.exports = l;
  })(At, At.exports)), At.exports;
}
var Xn, Co;
function Bf() {
  if (Co) return Xn;
  Co = 1;
  function e(t, r) {
    var n = -1, a = t.length;
    for (r || (r = Array(a)); ++n < a; )
      r[n] = t[n];
    return r;
  }
  return Xn = e, Xn;
}
var ea, Io;
function Gf() {
  if (Io) return ea;
  Io = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, s = 0, i = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (i[s++] = o);
    }
    return i;
  }
  return ea = e, ea;
}
var ta, xo;
function lu() {
  if (xo) return ta;
  xo = 1;
  function e() {
    return [];
  }
  return ta = e, ta;
}
var ra, ko;
function gs() {
  if (ko) return ra;
  ko = 1;
  var e = Gf(), t = lu(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, s = a ? function(i) {
    return i == null ? [] : (i = Object(i), e(a(i), function(o) {
      return n.call(i, o);
    }));
  } : t;
  return ra = s, ra;
}
var na, Oo;
function Ff() {
  if (Oo) return na;
  Oo = 1;
  var e = hr(), t = gs();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return na = r, na;
}
var aa, qo;
function du() {
  if (qo) return aa;
  qo = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, s = t.length; ++n < a; )
      t[s + n] = r[n];
    return t;
  }
  return aa = e, aa;
}
var sa, Po;
function fu() {
  if (Po) return sa;
  Po = 1;
  var e = cu(), t = e(Object.getPrototypeOf, Object);
  return sa = t, sa;
}
var ia, Vo;
function hu() {
  if (Vo) return ia;
  Vo = 1;
  var e = du(), t = fu(), r = gs(), n = lu(), a = Object.getOwnPropertySymbols, s = a ? function(i) {
    for (var o = []; i; )
      e(o, r(i)), i = t(i);
    return o;
  } : n;
  return ia = s, ia;
}
var oa, Mo;
function Zf() {
  if (Mo) return oa;
  Mo = 1;
  var e = hr(), t = hu();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return oa = r, oa;
}
var ca, No;
function pu() {
  if (No) return ca;
  No = 1;
  var e = du(), t = pr();
  function r(n, a, s) {
    var i = a(n);
    return t(n) ? i : e(i, s(n));
  }
  return ca = r, ca;
}
var ua, $o;
function yu() {
  if ($o) return ua;
  $o = 1;
  var e = pu(), t = gs(), r = ms();
  function n(a) {
    return e(a, r, t);
  }
  return ua = n, ua;
}
var la, Do;
function Wf() {
  if (Do) return la;
  Do = 1;
  var e = pu(), t = hu(), r = vs();
  function n(a) {
    return e(a, r, t);
  }
  return la = n, la;
}
var da, Ho;
function Jf() {
  if (Ho) return da;
  Ho = 1;
  var e = Fe(), t = fe(), r = e(t, "DataView");
  return da = r, da;
}
var fa, jo;
function zf() {
  if (jo) return fa;
  jo = 1;
  var e = Fe(), t = fe(), r = e(t, "Promise");
  return fa = r, fa;
}
var ha, Lo;
function Qf() {
  if (Lo) return ha;
  Lo = 1;
  var e = Fe(), t = fe(), r = e(t, "Set");
  return ha = r, ha;
}
var pa, Uo;
function Yf() {
  if (Uo) return pa;
  Uo = 1;
  var e = Fe(), t = fe(), r = e(t, "WeakMap");
  return pa = r, pa;
}
var ya, Ko;
function yr() {
  if (Ko) return ya;
  Ko = 1;
  var e = Jf(), t = ds(), r = zf(), n = Qf(), a = Yf(), s = lr(), i = eu(), o = "[object Map]", l = "[object Object]", u = "[object Promise]", h = "[object Set]", m = "[object WeakMap]", S = "[object DataView]", P = i(e), N = i(t), V = i(r), D = i(n), $ = i(a), C = s;
  return (e && C(new e(new ArrayBuffer(1))) != S || t && C(new t()) != o || r && C(r.resolve()) != u || n && C(new n()) != h || a && C(new a()) != m) && (C = function(B) {
    var O = s(B), G = O == l ? B.constructor : void 0, q = G ? i(G) : "";
    if (q)
      switch (q) {
        case P:
          return S;
        case N:
          return o;
        case V:
          return u;
        case D:
          return h;
        case $:
          return m;
      }
    return O;
  }), ya = C, ya;
}
var ma, Bo;
function Xf() {
  if (Bo) return ma;
  Bo = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var a = n.length, s = new n.constructor(a);
    return a && typeof n[0] == "string" && t.call(n, "index") && (s.index = n.index, s.input = n.input), s;
  }
  return ma = r, ma;
}
var va, Go;
function mu() {
  if (Go) return va;
  Go = 1;
  var e = fe(), t = e.Uint8Array;
  return va = t, va;
}
var ga, Fo;
function _s() {
  if (Fo) return ga;
  Fo = 1;
  var e = mu();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return ga = t, ga;
}
var _a, Zo;
function eh() {
  if (Zo) return _a;
  Zo = 1;
  var e = _s();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return _a = t, _a;
}
var ba, Wo;
function th() {
  if (Wo) return ba;
  Wo = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return ba = t, ba;
}
var Sa, Jo;
function rh() {
  if (Jo) return Sa;
  Jo = 1;
  var e = ur(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Sa = n, Sa;
}
var Aa, zo;
function nh() {
  if (zo) return Aa;
  zo = 1;
  var e = _s();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Aa = t, Aa;
}
var Ta, Qo;
function ah() {
  if (Qo) return Ta;
  Qo = 1;
  var e = _s(), t = eh(), r = th(), n = rh(), a = nh(), s = "[object Boolean]", i = "[object Date]", o = "[object Map]", l = "[object Number]", u = "[object RegExp]", h = "[object Set]", m = "[object String]", S = "[object Symbol]", P = "[object ArrayBuffer]", N = "[object DataView]", V = "[object Float32Array]", D = "[object Float64Array]", $ = "[object Int8Array]", C = "[object Int16Array]", B = "[object Int32Array]", O = "[object Uint8Array]", G = "[object Uint8ClampedArray]", q = "[object Uint16Array]", x = "[object Uint32Array]";
  function W(j, re, I) {
    var X = j.constructor;
    switch (re) {
      case P:
        return e(j);
      case s:
      case i:
        return new X(+j);
      case N:
        return t(j, I);
      case V:
      case D:
      case $:
      case C:
      case B:
      case O:
      case G:
      case q:
      case x:
        return a(j, I);
      case o:
        return new X();
      case l:
      case m:
        return new X(j);
      case u:
        return r(j);
      case h:
        return new X();
      case S:
        return n(j);
    }
  }
  return Ta = W, Ta;
}
var Ea, Yo;
function sh() {
  if (Yo) return Ea;
  Yo = 1;
  var e = kt(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (t)
        return t(a);
      n.prototype = a;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return Ea = r, Ea;
}
var Ra, Xo;
function ih() {
  if (Xo) return Ra;
  Xo = 1;
  var e = sh(), t = fu(), r = ys();
  function n(a) {
    return typeof a.constructor == "function" && !r(a) ? e(t(a)) : {};
  }
  return Ra = n, Ra;
}
var wa, ec;
function oh() {
  if (ec) return wa;
  ec = 1;
  var e = yr(), t = mt(), r = "[object Map]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return wa = n, wa;
}
var Ca, tc;
function ch() {
  if (tc) return Ca;
  tc = 1;
  var e = oh(), t = hs(), r = ps(), n = r && r.isMap, a = n ? t(n) : e;
  return Ca = a, Ca;
}
var Ia, rc;
function uh() {
  if (rc) return Ia;
  rc = 1;
  var e = yr(), t = mt(), r = "[object Set]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Ia = n, Ia;
}
var xa, nc;
function lh() {
  if (nc) return xa;
  nc = 1;
  var e = uh(), t = hs(), r = ps(), n = r && r.isSet, a = n ? t(n) : e;
  return xa = a, xa;
}
var ka, ac;
function dh() {
  if (ac) return ka;
  ac = 1;
  var e = ru(), t = xf(), r = au(), n = Hf(), a = Uf(), s = Kf(), i = Bf(), o = Ff(), l = Zf(), u = yu(), h = Wf(), m = yr(), S = Xf(), P = ah(), N = ih(), V = pr(), D = fs(), $ = ch(), C = kt(), B = lh(), O = ms(), G = vs(), q = 1, x = 2, W = 4, j = "[object Arguments]", re = "[object Array]", I = "[object Boolean]", X = "[object Date]", se = "[object Error]", Ye = "[object Function]", Xe = "[object GeneratorFunction]", qr = "[object Map]", dd = "[object Number]", Xs = "[object Object]", fd = "[object RegExp]", hd = "[object Set]", pd = "[object String]", yd = "[object Symbol]", md = "[object WeakMap]", vd = "[object ArrayBuffer]", gd = "[object DataView]", _d = "[object Float32Array]", bd = "[object Float64Array]", Sd = "[object Int8Array]", Ad = "[object Int16Array]", Td = "[object Int32Array]", Ed = "[object Uint8Array]", Rd = "[object Uint8ClampedArray]", wd = "[object Uint16Array]", Cd = "[object Uint32Array]", L = {};
  L[j] = L[re] = L[vd] = L[gd] = L[I] = L[X] = L[_d] = L[bd] = L[Sd] = L[Ad] = L[Td] = L[qr] = L[dd] = L[Xs] = L[fd] = L[hd] = L[pd] = L[yd] = L[Ed] = L[Rd] = L[wd] = L[Cd] = !0, L[se] = L[Ye] = L[md] = !1;
  function jt(H, et, tt, Id, Lt, Ae) {
    var ne, Ut = et & q, Kt = et & x, xd = et & W;
    if (tt && (ne = Lt ? tt(H, Id, Lt, Ae) : tt(H)), ne !== void 0)
      return ne;
    if (!C(H))
      return H;
    var ei = V(H);
    if (ei) {
      if (ne = S(H), !Ut)
        return i(H, ne);
    } else {
      var rt = m(H), ti = rt == Ye || rt == Xe;
      if (D(H))
        return s(H, Ut);
      if (rt == Xs || rt == j || ti && !Lt) {
        if (ne = Kt || ti ? {} : N(H), !Ut)
          return Kt ? l(H, a(ne, H)) : o(H, n(ne, H));
      } else {
        if (!L[rt])
          return Lt ? H : {};
        ne = P(H, rt, Ut);
      }
    }
    Ae || (Ae = new e());
    var ri = Ae.get(H);
    if (ri)
      return ri;
    Ae.set(H, ne), B(H) ? H.forEach(function(Te) {
      ne.add(jt(Te, et, tt, Te, H, Ae));
    }) : $(H) && H.forEach(function(Te, $e) {
      ne.set($e, jt(Te, et, tt, $e, H, Ae));
    });
    var kd = xd ? Kt ? h : u : Kt ? G : O, ni = ei ? void 0 : kd(H);
    return t(ni || H, function(Te, $e) {
      ni && ($e = Te, Te = H[$e]), r(ne, $e, jt(Te, et, tt, $e, H, Ae));
    }), ne;
  }
  return ka = jt, ka;
}
var Oa, sc;
function fh() {
  if (sc) return Oa;
  sc = 1;
  var e = dh(), t = 1, r = 4;
  function n(a) {
    return e(a, t | r);
  }
  return Oa = n, Oa;
}
var hh = fh();
const ph = /* @__PURE__ */ Qc(hh);
var M;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(M || (M = {}));
var ic;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(ic || (ic = {}));
const v = M.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (e) => {
  switch (typeof e) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return Number.isNaN(e) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(e) ? v.array : e === null ? v.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? v.promise : typeof Map < "u" && e instanceof Map ? v.map : typeof Set < "u" && e instanceof Set ? v.set : typeof Date < "u" && e instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, p = M.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Se extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, l = 0;
          for (; l < i.path.length; ) {
            const u = i.path[l];
            l === i.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(i))) : o[u] = o[u] || { _errors: [] }, o = o[u], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof Se))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, M.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Se.create = (e) => new Se(e);
const Ya = (e, t) => {
  let r;
  switch (e.code) {
    case p.invalid_type:
      e.received === v.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case p.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, M.jsonStringifyReplacer)}`;
      break;
    case p.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${M.joinValues(e.keys, ", ")}`;
      break;
    case p.invalid_union:
      r = "Invalid input";
      break;
    case p.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${M.joinValues(e.options)}`;
      break;
    case p.invalid_enum_value:
      r = `Invalid enum value. Expected ${M.joinValues(e.options)}, received '${e.received}'`;
      break;
    case p.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case p.invalid_return_type:
      r = "Invalid function return type";
      break;
    case p.invalid_date:
      r = "Invalid date";
      break;
    case p.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : M.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case p.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case p.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case p.custom:
      r = "Invalid input";
      break;
    case p.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case p.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case p.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, M.assertNever(e);
  }
  return { message: r };
};
let yh = Ya;
function mh() {
  return yh;
}
const vh = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const l = n.filter((u) => !!u).slice().reverse();
  for (const u of l)
    o = u(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function y(e, t) {
  const r = mh(), n = vh({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Ya ? void 0 : Ya
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class te {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return E;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return te.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return E;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const E = Object.freeze({
  status: "aborted"
}), Tt = (e) => ({ status: "dirty", value: e }), oe = (e) => ({ status: "valid", value: e }), oc = (e) => e.status === "aborted", cc = (e) => e.status === "dirty", ut = (e) => e.status === "valid", Ft = (e) => typeof Promise < "u" && e instanceof Promise;
var g;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t?.message;
})(g || (g = {}));
var Zt = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, vu = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, Et, Rt;
class le {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const uc = (e, t) => {
  if (ut(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Se(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function w(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: l } = e;
    return i.code === "invalid_enum_value" ? { message: l ?? o.defaultError } : typeof o.data > "u" ? { message: l ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: l ?? r ?? o.defaultError };
  }, description: a };
}
class k {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Re(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Re(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new te(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Re(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Ft(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: r?.async ?? !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return uc(n, a);
  }
  "~validate"(t) {
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    };
    if (!this["~standard"].async)
      try {
        const n = this._parseSync({ data: t, path: [], parent: r });
        return ut(n) ? {
          value: n.value
        } : {
          issues: r.common.issues
        };
      } catch (n) {
        n?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((n) => ut(n) ? {
      value: n.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Re(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Ft(a) ? a : Promise.resolve(a));
    return uc(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: p.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((l) => l ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Be({
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return be.create(this, this._def);
  }
  nullable() {
    return Ge.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ue.create(this);
  }
  promise() {
    return er.create(this, this._def);
  }
  or(t) {
    return Jt.create([this, t], this._def);
  }
  and(t) {
    return zt.create(this, t, this._def);
  }
  transform(t) {
    return new Be({
      ...w(this._def),
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new tr({
      ...w(this._def),
      innerType: this,
      defaultValue: r,
      typeName: T.ZodDefault
    });
  }
  brand() {
    return new Su({
      typeName: T.ZodBranded,
      type: this,
      ...w(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new rr({
      ...w(this._def),
      innerType: this,
      catchValue: r,
      typeName: T.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Ss.create(this, t);
  }
  readonly() {
    return nr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const gh = /^c[^\s-]{8,}$/i, _h = /^[0-9a-z]+$/, bh = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Sh = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ah = /^[a-z0-9_-]{21}$/i, Th = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Eh = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Rh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, wh = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let qa;
const Ch = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ih = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, xh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, kh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Oh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, qh = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, gu = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ph = new RegExp(`^${gu}$`);
function _u(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function Vh(e) {
  return new RegExp(`^${_u(e)}$`);
}
function Mh(e) {
  let t = `${gu}T${_u(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Nh(e, t) {
  return !!((t === "v4" || !t) && Ch.test(e) || (t === "v6" || !t) && xh.test(e));
}
function $h(e, t) {
  if (!Th.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && a?.typ !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Dh(e, t) {
  return !!((t === "v4" || !t) && Ih.test(e) || (t === "v6" || !t) && kh.test(e));
}
class _e extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== v.string) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.string,
        received: s.parsedType
      }), E;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Rh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "email",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        qa || (qa = new RegExp(wh, "u")), qa.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "emoji",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        Sh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "uuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        Ah.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "nanoid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        gh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        _h.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid2",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        bh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "ulid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), y(a, {
            validation: "url",
            code: p.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "regex",
        code: p.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Mh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Ph.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? Vh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Eh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "duration",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Nh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "ip",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? $h(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "jwt",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Dh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "cidr",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Oh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? qh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64url",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : M.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: p.invalid_string,
      ...g.errToObj(n)
    });
  }
  _addCheck(t) {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...g.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...g.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...g.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...g.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...g.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...g.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...g.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...g.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      offset: t?.offset ?? !1,
      local: t?.local ?? !1,
      ...g.errToObj(t?.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof t?.precision > "u" ? null : t?.precision,
      ...g.errToObj(t?.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...g.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...g.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r?.position,
      ...g.errToObj(r?.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...g.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...g.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...g.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, g.errToObj(t));
  }
  trim() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _e({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
_e.create = (e) => new _e({
  checks: [],
  typeName: T.ZodString,
  coerce: e?.coerce ?? !1,
  ...w(e)
});
function Hh(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class lt extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== v.number) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.number,
        received: s.parsedType
      }), E;
    }
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "int" ? M.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Hh(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_finite,
        message: s.message
      }), a.dirty()) : M.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new lt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new lt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: g.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && M.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
lt.create = (e) => new lt({
  checks: [],
  typeName: T.ZodNumber,
  coerce: e?.coerce || !1,
  ...w(e)
});
class wt extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== v.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new te();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : M.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.bigint,
      received: r.parsedType
    }), E;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new wt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new wt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
wt.create = (e) => new wt({
  checks: [],
  typeName: T.ZodBigInt,
  coerce: e?.coerce ?? !1,
  ...w(e)
});
class Xa extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== v.boolean) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), E;
    }
    return oe(t.data);
  }
}
Xa.create = (e) => new Xa({
  typeName: T.ZodBoolean,
  coerce: e?.coerce || !1,
  ...w(e)
});
class Wt extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== v.date) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.date,
        received: s.parsedType
      }), E;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_date
      }), E;
    }
    const n = new te();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : M.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Wt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Wt.create = (e) => new Wt({
  checks: [],
  coerce: e?.coerce || !1,
  typeName: T.ZodDate,
  ...w(e)
});
class lc extends k {
  _parse(t) {
    if (this._getType(t) !== v.symbol) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), E;
    }
    return oe(t.data);
  }
}
lc.create = (e) => new lc({
  typeName: T.ZodSymbol,
  ...w(e)
});
class es extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), E;
    }
    return oe(t.data);
  }
}
es.create = (e) => new es({
  typeName: T.ZodUndefined,
  ...w(e)
});
class ts extends k {
  _parse(t) {
    if (this._getType(t) !== v.null) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), E;
    }
    return oe(t.data);
  }
}
ts.create = (e) => new ts({
  typeName: T.ZodNull,
  ...w(e)
});
class Ct extends k {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return oe(t.data);
  }
}
Ct.create = (e) => new Ct({
  typeName: T.ZodAny,
  ...w(e)
});
class dc extends k {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return oe(t.data);
  }
}
dc.create = (e) => new dc({
  typeName: T.ZodUnknown,
  ...w(e)
});
class Ce extends k {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), E;
  }
}
Ce.create = (e) => new Ce({
  typeName: T.ZodNever,
  ...w(e)
});
class fc extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), E;
    }
    return oe(t.data);
  }
}
fc.create = (e) => new fc({
  typeName: T.ZodVoid,
  ...w(e)
});
class ue extends k {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== v.array)
      return y(r, {
        code: p.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), E;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (y(r, {
        code: i ? p.too_big : p.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (y(r, {
      code: p.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (y(r, {
      code: p.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new le(r, i, r.path, o)))).then((i) => te.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new le(r, i, r.path, o)));
    return te.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new ue({
      ...this._def,
      minLength: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new ue({
      ...this._def,
      maxLength: { value: t, message: g.toString(r) }
    });
  }
  length(t, r) {
    return new ue({
      ...this._def,
      exactLength: { value: t, message: g.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ue.create = (e, t) => new ue({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: T.ZodArray,
  ...w(t)
});
function it(e) {
  if (e instanceof Z) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = be.create(it(n));
    }
    return new Z({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof ue ? new ue({
    ...e._def,
    type: it(e.element)
  }) : e instanceof be ? be.create(it(e.unwrap())) : e instanceof Ge ? Ge.create(it(e.unwrap())) : e instanceof Ue ? Ue.create(e.items.map((t) => it(t))) : e;
}
class Z extends k {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = M.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== v.object) {
      const u = this._getOrReturnCtx(t);
      return y(u, {
        code: p.invalid_type,
        expected: v.object,
        received: u.parsedType
      }), E;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ce && this._def.unknownKeys === "strip"))
      for (const u in a.data)
        i.includes(u) || o.push(u);
    const l = [];
    for (const u of i) {
      const h = s[u], m = a.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: h._parse(new le(a, m, a.path, u)),
        alwaysSet: u in a.data
      });
    }
    if (this._def.catchall instanceof Ce) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const h of o)
          l.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (u === "strict")
        o.length > 0 && (y(a, {
          code: p.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const h of o) {
        const m = a.data[h];
        l.push({
          key: { status: "valid", value: h },
          value: u._parse(
            new le(a, m, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const h of l) {
        const m = await h.key, S = await h.value;
        u.push({
          key: m,
          value: S,
          alwaysSet: h.alwaysSet
        });
      }
      return u;
    }).then((u) => te.mergeObjectSync(n, u)) : te.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return g.errToObj, new Z({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          const a = this._def.errorMap?.(r, n).message ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: g.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new Z({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Z({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Z({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Z({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: T.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Z({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of M.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of M.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return it(this);
  }
  partial(t) {
    const r = {};
    for (const n of M.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of M.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof be; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new Z({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return bu(M.objectKeys(this.shape));
  }
}
Z.create = (e, t) => new Z({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: T.ZodObject,
  ...w(t)
});
Z.strictCreate = (e, t) => new Z({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Ce.create(),
  typeName: T.ZodObject,
  ...w(t)
});
Z.lazycreate = (e, t) => new Z({
  shape: e,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: T.ZodObject,
  ...w(t)
});
class Jt extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Se(o.ctx.common.issues));
      return y(r, {
        code: p.invalid_union,
        unionErrors: i
      }), E;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const l of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = l._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((l) => new Se(l));
      return y(r, {
        code: p.invalid_union,
        unionErrors: o
      }), E;
    }
  }
  get options() {
    return this._def.options;
  }
}
Jt.create = (e, t) => new Jt({
  options: e,
  typeName: T.ZodUnion,
  ...w(t)
});
const ge = (e) => e instanceof Yt ? ge(e.schema) : e instanceof Be ? ge(e.innerType()) : e instanceof Xt ? [e.value] : e instanceof Ke ? e.options : e instanceof ns ? M.objectValues(e.enum) : e instanceof tr ? ge(e._def.innerType) : e instanceof es ? [void 0] : e instanceof ts ? [null] : e instanceof be ? [void 0, ...ge(e.unwrap())] : e instanceof Ge ? [null, ...ge(e.unwrap())] : e instanceof Su || e instanceof nr ? ge(e.unwrap()) : e instanceof rr ? ge(e._def.innerType) : [];
class bs extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.object)
      return y(r, {
        code: p.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), E;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (y(r, {
      code: p.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), E);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = ge(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new bs({
      typeName: T.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...w(n)
    });
  }
}
function rs(e, t) {
  const r = Re(e), n = Re(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === v.object && n === v.object) {
    const a = M.objectKeys(t), s = M.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const l = rs(e[o], t[o]);
      if (!l.valid)
        return { valid: !1 };
      i[o] = l.data;
    }
    return { valid: !0, data: i };
  } else if (r === v.array && n === v.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], l = rs(i, o);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === v.date && n === v.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class zt extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (oc(s) || oc(i))
        return E;
      const o = rs(s.value, i.value);
      return o.valid ? ((cc(s) || cc(i)) && r.dirty(), { status: r.value, value: o.data }) : (y(n, {
        code: p.invalid_intersection_types
      }), E);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
zt.create = (e, t, r) => new zt({
  left: e,
  right: t,
  typeName: T.ZodIntersection,
  ...w(r)
});
class Ue extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.array)
      return y(n, {
        code: p.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), E;
    if (n.data.length < this._def.items.length)
      return y(n, {
        code: p.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), E;
    !this._def.rest && n.data.length > this._def.items.length && (y(n, {
      code: p.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new le(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => te.mergeArray(r, i)) : te.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Ue({
      ...this._def,
      rest: t
    });
  }
}
Ue.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ue({
    items: e,
    typeName: T.ZodTuple,
    rest: null,
    ...w(t)
  });
};
class Qt extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.object)
      return y(n, {
        code: p.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), E;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new le(n, o, n.path, o)),
        value: i._parse(new le(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? te.mergeObjectAsync(r, a) : te.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof k ? new Qt({
      keyType: t,
      valueType: r,
      typeName: T.ZodRecord,
      ...w(n)
    }) : new Qt({
      keyType: _e.create(),
      valueType: t,
      typeName: T.ZodRecord,
      ...w(r)
    });
  }
}
class hc extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.map)
      return y(n, {
        code: p.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), E;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, l], u) => ({
      key: a._parse(new le(n, o, n.path, [u, "key"])),
      value: s._parse(new le(n, l, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of i) {
          const u = await l.key, h = await l.value;
          if (u.status === "aborted" || h.status === "aborted")
            return E;
          (u.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(u.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of i) {
        const u = l.key, h = l.value;
        if (u.status === "aborted" || h.status === "aborted")
          return E;
        (u.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(u.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
hc.create = (e, t, r) => new hc({
  valueType: t,
  keyType: e,
  typeName: T.ZodMap,
  ...w(r)
});
class It extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.set)
      return y(n, {
        code: p.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), E;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (y(n, {
      code: p.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (y(n, {
      code: p.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(l) {
      const u = /* @__PURE__ */ new Set();
      for (const h of l) {
        if (h.status === "aborted")
          return E;
        h.status === "dirty" && r.dirty(), u.add(h.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...n.data.values()].map((l, u) => s._parse(new le(n, l, n.path, u)));
    return n.common.async ? Promise.all(o).then((l) => i(l)) : i(o);
  }
  min(t, r) {
    return new It({
      ...this._def,
      minSize: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new It({
      ...this._def,
      maxSize: { value: t, message: g.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
It.create = (e, t) => new It({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: T.ZodSet,
  ...w(t)
});
class Yt extends k {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Yt.create = (e, t) => new Yt({
  getter: e,
  typeName: T.ZodLazy,
  ...w(t)
});
class Xt extends k {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return y(r, {
        received: r.data,
        code: p.invalid_literal,
        expected: this._def.value
      }), E;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Xt.create = (e, t) => new Xt({
  value: e,
  typeName: T.ZodLiteral,
  ...w(t)
});
function bu(e, t) {
  return new Ke({
    values: e,
    typeName: T.ZodEnum,
    ...w(t)
  });
}
class Ke extends k {
  constructor() {
    super(...arguments), Et.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        expected: M.joinValues(n),
        received: r.parsedType,
        code: p.invalid_type
      }), E;
    }
    if (Zt(this, Et, "f") || vu(this, Et, new Set(this._def.values), "f"), !Zt(this, Et, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        received: r.data,
        code: p.invalid_enum_value,
        options: n
      }), E;
    }
    return oe(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Ke.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Ke.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Et = /* @__PURE__ */ new WeakMap();
Ke.create = bu;
class ns extends k {
  constructor() {
    super(...arguments), Rt.set(this, void 0);
  }
  _parse(t) {
    const r = M.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const a = M.objectValues(r);
      return y(n, {
        expected: M.joinValues(a),
        received: n.parsedType,
        code: p.invalid_type
      }), E;
    }
    if (Zt(this, Rt, "f") || vu(this, Rt, new Set(M.getValidEnumValues(this._def.values)), "f"), !Zt(this, Rt, "f").has(t.data)) {
      const a = M.objectValues(r);
      return y(n, {
        received: n.data,
        code: p.invalid_enum_value,
        options: a
      }), E;
    }
    return oe(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Rt = /* @__PURE__ */ new WeakMap();
ns.create = (e, t) => new ns({
  values: e,
  typeName: T.ZodNativeEnum,
  ...w(t)
});
class er extends k {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return y(r, {
        code: p.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), E;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return oe(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
er.create = (e, t) => new er({
  type: e,
  typeName: T.ZodPromise,
  ...w(t)
});
class Be extends k {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === T.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        y(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return E;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? E : l.status === "dirty" || r.value === "dirty" ? Tt(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return E;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? E : o.status === "dirty" || r.value === "dirty" ? Tt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const l = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? E : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? E : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!ut(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => ut(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    M.assertNever(a);
  }
}
Be.create = (e, t, r) => new Be({
  schema: e,
  typeName: T.ZodEffects,
  effect: t,
  ...w(r)
});
Be.createWithPreprocess = (e, t, r) => new Be({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: T.ZodEffects,
  ...w(r)
});
class be extends k {
  _parse(t) {
    return this._getType(t) === v.undefined ? oe(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
be.create = (e, t) => new be({
  innerType: e,
  typeName: T.ZodOptional,
  ...w(t)
});
class Ge extends k {
  _parse(t) {
    return this._getType(t) === v.null ? oe(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ge.create = (e, t) => new Ge({
  innerType: e,
  typeName: T.ZodNullable,
  ...w(t)
});
class tr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
tr.create = (e, t) => new tr({
  innerType: e,
  typeName: T.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...w(t)
});
class rr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Ft(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Se(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Se(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
rr.create = (e, t) => new rr({
  innerType: e,
  typeName: T.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...w(t)
});
class pc extends k {
  _parse(t) {
    if (this._getType(t) !== v.nan) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), E;
    }
    return { status: "valid", value: t.data };
  }
}
pc.create = (e) => new pc({
  typeName: T.ZodNaN,
  ...w(e)
});
class Su extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ss extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? E : s.status === "dirty" ? (r.dirty(), Tt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? E : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Ss({
      in: t,
      out: r,
      typeName: T.ZodPipeline
    });
  }
}
class nr extends k {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (ut(a) && (a.value = Object.freeze(a.value)), a);
    return Ft(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
nr.create = (e, t) => new nr({
  innerType: e,
  typeName: T.ZodReadonly,
  ...w(t)
});
function yc(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function As(e, t = {}, r) {
  return e ? Ct.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = yc(t, n), l = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: l });
        }
      });
    if (!s) {
      const i = yc(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : Ct.create();
}
var T;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(T || (T = {}));
const mr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => As((r) => r instanceof e, t), c = _e.create, Ze = lt.create, R = Xa.create;
Ct.create;
Ce.create;
const b = ue.create, f = Z.create, U = Jt.create, K = bs.create;
zt.create;
Ue.create;
const jh = Qt.create, ae = Yt.create, d = Xt.create, ee = Ke.create;
er.create;
const ie = be.create;
Ge.create;
var _ = (e) => e, Lh = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null) return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t) return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Returns the Zod schema for the latest version of the entity.
   * 
   * @example
   * ```ts
   * const UserEntity = createVersionedEntity({ ... })
   * const latestSchema = UserEntity.latestSchema
   * ```
   */
  get latestSchema() {
    return this.versionMap[this.latestVersion].schema;
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function We(e) {
  return new Lh(e.versionMap, e.latestVersion, e.getVersion);
}
function dt(e) {
  return As((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function ce(e, t) {
  return As((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var Pa, mc;
function Uh() {
  if (mc) return Pa;
  mc = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Pa = t, Pa;
}
var Va, vc;
function Kh() {
  if (vc) return Va;
  vc = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Va = e, Va;
}
var Ma, gc;
function Bh() {
  if (gc) return Ma;
  gc = 1;
  var e = tu(), t = Uh(), r = Kh();
  function n(a) {
    var s = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++s < i; )
      this.add(a[s]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Ma = n, Ma;
}
var Na, _c;
function Gh() {
  if (_c) return Na;
  _c = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Na = e, Na;
}
var $a, bc;
function Fh() {
  if (bc) return $a;
  bc = 1;
  function e(t, r) {
    return t.has(r);
  }
  return $a = e, $a;
}
var Da, Sc;
function Au() {
  if (Sc) return Da;
  Sc = 1;
  var e = Bh(), t = Gh(), r = Fh(), n = 1, a = 2;
  function s(i, o, l, u, h, m) {
    var S = l & n, P = i.length, N = o.length;
    if (P != N && !(S && N > P))
      return !1;
    var V = m.get(i), D = m.get(o);
    if (V && D)
      return V == o && D == i;
    var $ = -1, C = !0, B = l & a ? new e() : void 0;
    for (m.set(i, o), m.set(o, i); ++$ < P; ) {
      var O = i[$], G = o[$];
      if (u)
        var q = S ? u(G, O, $, o, i, m) : u(O, G, $, i, o, m);
      if (q !== void 0) {
        if (q)
          continue;
        C = !1;
        break;
      }
      if (B) {
        if (!t(o, function(x, W) {
          if (!r(B, W) && (O === x || h(O, x, l, u, m)))
            return B.push(W);
        })) {
          C = !1;
          break;
        }
      } else if (!(O === G || h(O, G, l, u, m))) {
        C = !1;
        break;
      }
    }
    return m.delete(i), m.delete(o), C;
  }
  return Da = s, Da;
}
var Ha, Ac;
function Zh() {
  if (Ac) return Ha;
  Ac = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, s) {
      n[++r] = [s, a];
    }), n;
  }
  return Ha = e, Ha;
}
var ja, Tc;
function Wh() {
  if (Tc) return ja;
  Tc = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return ja = e, ja;
}
var La, Ec;
function Jh() {
  if (Ec) return La;
  Ec = 1;
  var e = ur(), t = mu(), r = ls(), n = Au(), a = Zh(), s = Wh(), i = 1, o = 2, l = "[object Boolean]", u = "[object Date]", h = "[object Error]", m = "[object Map]", S = "[object Number]", P = "[object RegExp]", N = "[object Set]", V = "[object String]", D = "[object Symbol]", $ = "[object ArrayBuffer]", C = "[object DataView]", B = e ? e.prototype : void 0, O = B ? B.valueOf : void 0;
  function G(q, x, W, j, re, I, X) {
    switch (W) {
      case C:
        if (q.byteLength != x.byteLength || q.byteOffset != x.byteOffset)
          return !1;
        q = q.buffer, x = x.buffer;
      case $:
        return !(q.byteLength != x.byteLength || !I(new t(q), new t(x)));
      case l:
      case u:
      case S:
        return r(+q, +x);
      case h:
        return q.name == x.name && q.message == x.message;
      case P:
      case V:
        return q == x + "";
      case m:
        var se = a;
      case N:
        var Ye = j & i;
        if (se || (se = s), q.size != x.size && !Ye)
          return !1;
        var Xe = X.get(q);
        if (Xe)
          return Xe == x;
        j |= o, X.set(q, x);
        var qr = n(se(q), se(x), j, re, I, X);
        return X.delete(q), qr;
      case D:
        if (O)
          return O.call(q) == O.call(x);
    }
    return !1;
  }
  return La = G, La;
}
var Ua, Rc;
function zh() {
  if (Rc) return Ua;
  Rc = 1;
  var e = yu(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o, l, u, h) {
    var m = o & t, S = e(s), P = S.length, N = e(i), V = N.length;
    if (P != V && !m)
      return !1;
    for (var D = P; D--; ) {
      var $ = S[D];
      if (!(m ? $ in i : n.call(i, $)))
        return !1;
    }
    var C = h.get(s), B = h.get(i);
    if (C && B)
      return C == i && B == s;
    var O = !0;
    h.set(s, i), h.set(i, s);
    for (var G = m; ++D < P; ) {
      $ = S[D];
      var q = s[$], x = i[$];
      if (l)
        var W = m ? l(x, q, $, i, s, h) : l(q, x, $, s, i, h);
      if (!(W === void 0 ? q === x || u(q, x, o, l, h) : W)) {
        O = !1;
        break;
      }
      G || (G = $ == "constructor");
    }
    if (O && !G) {
      var j = s.constructor, re = i.constructor;
      j != re && "constructor" in s && "constructor" in i && !(typeof j == "function" && j instanceof j && typeof re == "function" && re instanceof re) && (O = !1);
    }
    return h.delete(s), h.delete(i), O;
  }
  return Ua = a, Ua;
}
var Ka, wc;
function Qh() {
  if (wc) return Ka;
  wc = 1;
  var e = ru(), t = Au(), r = Jh(), n = zh(), a = yr(), s = pr(), i = fs(), o = iu(), l = 1, u = "[object Arguments]", h = "[object Array]", m = "[object Object]", S = Object.prototype, P = S.hasOwnProperty;
  function N(V, D, $, C, B, O) {
    var G = s(V), q = s(D), x = G ? h : a(V), W = q ? h : a(D);
    x = x == u ? m : x, W = W == u ? m : W;
    var j = x == m, re = W == m, I = x == W;
    if (I && i(V)) {
      if (!i(D))
        return !1;
      G = !0, j = !1;
    }
    if (I && !j)
      return O || (O = new e()), G || o(V) ? t(V, D, $, C, B, O) : r(V, D, x, $, C, B, O);
    if (!($ & l)) {
      var X = j && P.call(V, "__wrapped__"), se = re && P.call(D, "__wrapped__");
      if (X || se) {
        var Ye = X ? V.value() : V, Xe = se ? D.value() : D;
        return O || (O = new e()), B(Ye, Xe, $, C, O);
      }
    }
    return I ? (O || (O = new e()), n(V, D, $, C, B, O)) : !1;
  }
  return Ka = N, Ka;
}
var Ba, Cc;
function Yh() {
  if (Cc) return Ba;
  Cc = 1;
  var e = Qh(), t = mt();
  function r(n, a, s, i, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, s, i, r, o);
  }
  return Ba = r, Ba;
}
var Ga, Ic;
function Xh() {
  if (Ic) return Ga;
  Ic = 1;
  var e = Yh();
  function t(r, n) {
    return e(r, n);
  }
  return Ga = t, Ga;
}
var ep = Xh();
const tp = /* @__PURE__ */ Qc(ep), xc = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), Fa = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), De = {
  equals(e, t) {
    return tp(e, t);
  }
}, rp = f({
  id: ie(c()),
  // Firebase Firestore ID
  url: c(),
  path: c(),
  headers: b(
    f({
      key: c(),
      value: c(),
      active: R()
    })
  ),
  params: b(
    f({
      key: c(),
      value: c(),
      active: R()
    })
  ),
  name: c(),
  method: c(),
  preRequestScript: c(),
  testScript: c(),
  contentType: c(),
  body: c(),
  rawParams: ie(c()),
  auth: ie(c()),
  httpUser: ie(c()),
  httpPassword: ie(c()),
  bearerToken: ie(c())
}), kc = _({
  initial: !0,
  schema: rp
}), Ts = f({
  key: c(),
  active: R()
}).and(
  U([
    f({
      isFile: d(!0),
      value: b(mr(Blob).nullable())
    }),
    f({
      isFile: d(!1),
      value: c()
    })
  ])
);
f({
  contentType: d("multipart/form-data"),
  body: b(Ts)
});
const np = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Ts).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), he = f({
  authType: d("none")
}), pe = f({
  authType: d("basic"),
  username: c().catch(""),
  password: c().catch("")
}), ye = f({
  authType: d("bearer"),
  token: c().catch("")
}), ap = f({
  authType: d("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), Es = f({
  authType: d("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), me = f({
  authType: d("inherit")
}), sp = K("authType", [
  he,
  me,
  pe,
  ye,
  ap,
  Es
]).and(
  f({
    authActive: R()
  })
), ip = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: R().catch(!0)
  })
), Tu = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: R().catch(!0)
  })
), Eu = f({
  v: d("1"),
  id: ie(c()),
  // Firebase Firestore ID
  name: c(),
  method: c(),
  endpoint: c(),
  params: ip,
  headers: Tu,
  preRequestScript: c().catch(""),
  testScript: c().catch(""),
  auth: sp,
  body: np
});
function op(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function cp(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const up = _({
  initial: !1,
  schema: Eu,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l
    } = e, u = `${t}${r}`, h = op(e), m = cp(e), S = {
      v: "1",
      endpoint: u,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l,
      body: h,
      auth: m
    };
    return e.id && (S.id = e.id), S;
  }
}), Rs = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: R().catch(!0)
  })
), Ru = Eu.extend({
  v: d("2"),
  requestVariables: Rs
}), lp = _({
  initial: !1,
  schema: Ru,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), wu = f({
  grantType: d("AUTHORIZATION_CODE"),
  authEndpoint: c().trim(),
  tokenEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch(""),
  isPKCE: R(),
  codeVerifierMethod: U([d("plain"), d("S256")]).optional()
}), vr = f({
  grantType: d("CLIENT_CREDENTIALS"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), gr = f({
  grantType: d("PASSWORD"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  username: c().trim(),
  password: c().trim(),
  token: c().catch("")
}), vt = f({
  grantType: d("IMPLICIT"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), _r = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    wu,
    vr,
    gr,
    vt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), dp = K("authType", [
  he,
  me,
  pe,
  ye,
  _r,
  Es
]).and(
  f({
    authActive: R()
  })
), Cu = Ru.extend({
  v: d("3"),
  auth: dp
}), fp = _({
  initial: !1,
  schema: Cu,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), ke = Es.extend({
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), hp = K("authType", [
  he,
  me,
  pe,
  ye,
  _r,
  ke
]).and(
  f({
    authActive: R()
  })
), Iu = Cu.extend({
  v: d("4"),
  auth: hp
}), pp = _({
  schema: Iu,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), xu = wu.extend({
  clientSecret: c().optional()
}), br = _r.extend({
  grantTypeInfo: K("grantType", [
    xu,
    vr,
    gr,
    vt
  ])
}), ku = K("authType", [
  he,
  me,
  pe,
  ye,
  br,
  ke
]).and(
  f({
    authActive: R()
  })
), Ou = Iu.extend({
  v: d("5"),
  auth: ku
}), yp = _({
  schema: Ou,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), qu = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Ts).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), Pu = Ou.extend({
  v: d("6"),
  body: qu
}), mp = _({
  schema: Pu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), Sr = xu.extend({
  refreshToken: c().optional()
}), Vu = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Sr,
    vr,
    gr,
    vt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ws = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: R().catch(!0),
    description: c().catch("")
  })
), Ar = b(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: R().catch(!0),
    description: c().catch("")
  })
), Je = f({
  authType: d("aws-signature"),
  accessKey: c().catch(""),
  secretKey: c().catch(""),
  region: c().catch(""),
  serviceName: c().catch(""),
  serviceToken: c().optional(),
  signature: f({}).optional(),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Mu = K("authType", [
  he,
  me,
  pe,
  ye,
  Vu,
  ke,
  Je
]).and(
  f({
    authActive: R()
  })
), Nu = Pu.extend({
  v: d("7"),
  params: ws,
  headers: Ar,
  auth: Mu
}), vp = _({
  schema: Nu,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), $u = vr.extend({
  clientSecret: c().optional()
}), Cs = gr.extend({
  clientSecret: c().optional()
}), gp = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Sr,
    $u,
    Cs,
    vt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ot = f({
  authType: d("digest"),
  username: c().catch(""),
  password: c().catch(""),
  realm: c().catch(""),
  nonce: c().catch(""),
  algorithm: ee(["MD5", "MD5-sess"]).catch("MD5"),
  qop: ee(["auth", "auth-int"]).catch("auth"),
  nc: c().catch(""),
  cnonce: c().catch(""),
  opaque: c().catch(""),
  disableRetry: R().catch(!1)
}), Is = K("authType", [
  he,
  me,
  pe,
  ye,
  gp,
  ke,
  Je,
  Ot
]).and(
  f({
    authActive: R()
  })
), Du = f({
  v: d("1"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: Ar,
  params: ws,
  body: qu,
  auth: Is,
  requestVariables: Rs
}), Oc = _({
  initial: !0,
  schema: Du
}), Hu = f({
  key: c(),
  active: R(),
  contentType: c().optional().catch(void 0)
}).and(
  U([
    f({
      isFile: d(!0),
      value: b(mr(Blob).nullable()).catch([])
    }),
    f({
      isFile: d(!1),
      value: c()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), ju = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Hu).catch([]),
    showIndividualContentType: R().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: mr(File).nullable().catch(null)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), Lu = Du.extend({
  v: d("2"),
  body: ju
}), _p = _({
  initial: !1,
  schema: Lu,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), Uu = $u.extend({
  clientAuthentication: ee(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Tr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Sr,
    Uu,
    Cs,
    vt
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), xs = K("authType", [
  he,
  me,
  pe,
  ye,
  Tr,
  ke,
  Je,
  Ot
]).and(
  f({
    authActive: R()
  })
), ks = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: b(Hu).catch([]),
    showIndividualContentType: R().optional().catch(!1),
    isBulkEditing: R().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: mr(File).nullable().catch(null)
  }),
  f({
    contentType: d("application/x-www-form-urlencoded"),
    body: c().catch(""),
    isBulkEditing: R().optional().catch(!1)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: c().catch("")
  })
]), Ku = Lu.extend({
  v: d("3"),
  auth: xs,
  body: ks
}), bp = _({
  initial: !1,
  schema: Ku,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Os = f({
  authType: d("hawk"),
  authId: c().catch(""),
  authKey: c().catch(""),
  algorithm: ee(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: R().catch(!1),
  // Optional fields
  user: c().optional(),
  nonce: c().optional(),
  ext: c().optional(),
  app: c().optional(),
  dlg: c().optional(),
  timestamp: c().optional()
}), qs = f({
  authType: d("akamai-eg"),
  accessToken: c().catch(""),
  clientToken: c().catch(""),
  clientSecret: c().catch(""),
  // Optional fields
  nonce: c().optional(),
  timestamp: c().optional(),
  host: c().optional(),
  headersToSign: c().optional(),
  maxBodySize: c().optional()
}), Ps = K("authType", [
  he,
  me,
  pe,
  ye,
  Tr,
  ke,
  Je,
  Ot,
  Os,
  qs
]).and(
  f({
    authActive: R()
  })
), Bu = Ku.extend({
  v: d("4"),
  auth: Ps
}), Sp = _({
  initial: !1,
  schema: Bu,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), Gu = f({
  authType: d("jwt"),
  secret: c().catch(""),
  privateKey: c().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: ee([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: c().catch("{}"),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: R().catch(!1),
  headerPrefix: c().catch("Bearer "),
  paramName: c().catch("token"),
  jwtHeaders: c().catch("{}")
}), Vs = K("authType", [
  he,
  me,
  pe,
  ye,
  Tr,
  ke,
  Je,
  Ot,
  Os,
  qs,
  Gu
]).and(
  f({
    authActive: R()
  })
), Fu = Bu.extend({
  v: d("5"),
  auth: Vs
}), Ap = _({
  initial: !1,
  schema: Fu,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Ie = f({
  id: Ze(),
  key: c(),
  value: c(),
  active: R(),
  sendIn: ee(["headers", "url", "body"]).catch("headers")
}), Zu = Ie.omit({ sendIn: !0 }), Tp = Sr.extend({
  authRequestParams: b(Zu).optional().default([]),
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), Ep = Uu.extend({
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), Rp = Cs.extend({
  tokenRequestParams: b(Ie).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), wp = vt.extend({
  authRequestParams: b(Zu).optional().default([]),
  refreshRequestParams: b(Ie).optional().default([])
}), Wu = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Tp,
    Ep,
    Rp,
    wp
  ]),
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Er = K("authType", [
  he,
  me,
  pe,
  ye,
  Wu,
  ke,
  Je,
  Ot,
  Os,
  qs,
  Gu
]).and(
  f({
    authActive: R()
  })
), Cp = Fu.extend({
  v: d("6"),
  auth: Er
}), Ip = _({
  initial: !1,
  schema: Cp,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "6",
      auth: t
    };
  }
}), xp = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), kp = We({
  latestVersion: 6,
  versionMap: {
    1: Oc,
    2: _p,
    3: bp,
    4: Sp,
    5: Ap,
    6: Ip
  },
  getVersion(e) {
    const t = xp.safeParse(e);
    return t.success ? t.data.v : Oc.schema.safeParse(e).success ? 1 : null;
  }
}), Op = "6", qp = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Pp = U(
  Object.keys(qp).map((e) => d(parseInt(e)))
), Vp = b(
  f({
    key: c(),
    value: c()
  })
), Mp = f({
  name: c(),
  originalRequest: dt(kp),
  status: c(),
  code: ie(Pp).nullable().catch(null),
  headers: Vp,
  body: c()
}), qc = _({
  initial: !0,
  schema: Mp
}), Np = f({
  v: Ze()
}), $p = We({
  latestVersion: 0,
  versionMap: {
    0: qc
  },
  getVersion(e) {
    const t = Np.safeParse(e);
    return t.success ? t.data.v : qc.schema.safeParse(e).success ? 0 : null;
  }
}), Ju = jh(
  c(),
  dt($p)
);
function cg(e) {
  return {
    v: Op,
    ...e
  };
}
const zu = Nu.extend({
  v: d("8"),
  auth: Is,
  responses: Ju
}), Dp = _({
  schema: zu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), Qu = zu.extend({
  v: d("9"),
  body: ju
}), Hp = _({
  schema: Qu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), Yu = Qu.extend({
  v: d("10"),
  body: ks
}), jp = _({
  schema: Yu,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), Xu = Yu.extend({
  v: d("11"),
  auth: xs
}), Lp = _({
  schema: Xu,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), el = Xu.extend({
  v: d("12"),
  auth: Ps
}), Up = _({
  schema: el,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), tl = el.extend({
  v: d("13"),
  auth: Vs
}), Kp = _({
  schema: tl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), rl = tl.extend({
  v: d("14")
}), Bp = _({
  schema: rl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), nl = rl.extend({
  v: d("15"),
  auth: Er
}), Gp = _({
  schema: nl,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "15",
      auth: t
    };
  }
}), Y = [];
for (let e = 0; e < 256; ++e)
  Y.push((e + 256).toString(16).slice(1));
function Fp(e, t = 0) {
  return (Y[e[t + 0]] + Y[e[t + 1]] + Y[e[t + 2]] + Y[e[t + 3]] + "-" + Y[e[t + 4]] + Y[e[t + 5]] + "-" + Y[e[t + 6]] + Y[e[t + 7]] + "-" + Y[e[t + 8]] + Y[e[t + 9]] + "-" + Y[e[t + 10]] + Y[e[t + 11]] + Y[e[t + 12]] + Y[e[t + 13]] + Y[e[t + 14]] + Y[e[t + 15]]).toLowerCase();
}
let Za;
const Zp = new Uint8Array(16);
function Wp() {
  if (!Za) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Za = crypto.getRandomValues.bind(crypto);
  }
  return Za(Zp);
}
const Jp = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Pc = { randomUUID: Jp };
function zp(e, t, r) {
  e = e || {};
  const n = e.random ?? e.rng?.() ?? Wp();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Fp(n);
}
function Qp(e, t, r) {
  return Pc.randomUUID && !e ? Pc.randomUUID() : zp(e);
}
const qt = (e = "") => {
  const t = Date.now().toString(36), r = Qp();
  return `${e}_${t}_${r}`;
}, al = nl.extend({
  v: d("16"),
  _ref_id: c().optional()
}), Yp = _({
  schema: al,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "16",
      _ref_id: qt("req")
    };
  }
}), Xp = al.extend({
  v: d("17"),
  description: c().nullable().catch(null)
}), ey = _({
  schema: Xp,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "17",
      description: null
    };
  }
}), ty = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, ug = Object.keys(
  ty
), ry = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Rr = We({
  latestVersion: 17,
  versionMap: {
    0: kc,
    1: up,
    2: lp,
    3: fp,
    4: pp,
    5: yp,
    6: mp,
    7: vp,
    8: Dp,
    9: Hp,
    10: jp,
    11: Lp,
    12: Up,
    13: Kp,
    14: Bp,
    15: Gp,
    16: Yp,
    17: ey
  },
  getVersion(e) {
    const t = ry.safeParse(e);
    return t.success ? t.data.v : kc.schema.safeParse(e).success ? 0 : null;
  }
}), ny = Md({
  id: xc(ve),
  v: ve,
  auth: De,
  body: De,
  endpoint: ve,
  headers: Fa(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  params: Fa(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  method: ve,
  name: ve,
  preRequestScript: ve,
  testScript: ve,
  requestVariables: Fa(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    De
  ),
  responses: De,
  _ref_id: xc(ve),
  description: De
}), sl = "17", lg = ny.equals;
function dg(e, t) {
  const r = ph(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "_ref_id" in e && typeof e._ref_id == "string" && (r._ref_id = e._ref_id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = ks.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = Er.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = ws.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = Ar.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Rs.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = Ju.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
    "description" in e && typeof e.description == "string" && (r.description = e.description);
  }
  return r;
}
function fg(e) {
  return {
    v: sl,
    _ref_id: e._ref_id ?? qt("req"),
    ...e
  };
}
function ay() {
  const e = qt("req");
  return {
    v: sl,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {},
    _ref_id: e,
    description: null
  };
}
function hg(e) {
  return Rr.isLatest(e);
}
function sy(e) {
  const t = Rr.safeParse(e);
  return t.type === "ok" ? t.value : ay();
}
const Ms = f({
  key: c().catch(""),
  value: c().catch(""),
  active: R().catch(!0)
}), iy = f({
  v: d(1),
  name: c(),
  url: c(),
  headers: b(Ms).catch([]),
  query: c(),
  variables: c()
}), oy = _({
  initial: !0,
  schema: iy
}), Oe = f({
  authType: d("none")
}), qe = f({
  authType: d("basic"),
  username: c().catch(""),
  password: c().catch("")
}), Pe = f({
  authType: d("bearer"),
  token: c().catch("")
}), cy = f({
  authType: d("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), Ns = f({
  authType: d("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), Ve = f({
  authType: d("inherit")
}), uy = K("authType", [
  Oe,
  qe,
  Pe,
  cy,
  Ns,
  Ve
]).and(
  f({
    authActive: R()
  })
), il = f({
  id: ie(c()),
  v: d(2),
  name: c(),
  url: c(),
  headers: b(Ms).catch([]),
  query: c(),
  variables: c(),
  auth: uy
}), ly = _({
  initial: !1,
  schema: il,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), dy = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  Ns,
  _r
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: R()
  })
), ol = il.extend({
  v: d(3),
  auth: dy
}), fy = _({
  initial: !1,
  schema: ol,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), gt = Ns.extend({
  addTo: ee(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), hy = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  gt,
  br
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: R()
  })
), cl = ol.extend({
  v: d(4),
  auth: hy
}), py = _({
  initial: !1,
  schema: cl,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), ul = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  gt,
  br
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: R()
  })
), ll = cl.extend({
  v: d(5),
  auth: ul
}), yy = _({
  initial: !1,
  schema: ll,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), wr = Je, dl = f({
  key: c().catch(""),
  value: c().catch(""),
  active: R().catch(!0),
  description: c().catch("")
}), fl = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  br,
  gt,
  wr
]).and(
  f({
    authActive: R()
  })
), hl = ll.extend({
  v: d(6),
  auth: fl,
  headers: b(dl).catch([])
}), my = _({
  schema: hl,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), pl = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  Vu,
  gt,
  wr
]).and(
  f({
    authActive: R()
  })
), yl = hl.extend({
  v: d(7),
  auth: pl
}), vy = _({
  schema: yl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Cr = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  Tr,
  gt,
  wr
]).and(
  f({
    authActive: R()
  })
), ml = yl.extend({
  v: d(8),
  auth: Cr
}), gy = _({
  schema: ml,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), vl = K("authType", [
  Oe,
  Ve,
  qe,
  Pe,
  Wu,
  gt,
  wr
]).and(
  f({
    authActive: R()
  })
), _y = ml.extend({
  v: d(9),
  auth: vl
}), by = _({
  schema: _y,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t
    };
  }
}), gl = 9, Sy = f({
  v: Ze()
}), $s = We({
  latestVersion: 9,
  versionMap: {
    1: oy,
    2: ly,
    3: fy,
    4: py,
    5: yy,
    6: my,
    7: vy,
    8: gy,
    9: by
  },
  getVersion(e) {
    const t = Sy.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), Ay = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function Ty() {
  return {
    v: gl,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: Ay,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function Ey(e) {
  const t = $s.safeParse(e);
  return t.type === "ok" ? t.value : Ty();
}
function pg(e) {
  return {
    v: gl,
    ...e
  };
}
const Ry = f({
  v: d(1),
  id: ie(c()),
  // For Firestore ID data
  name: c(),
  requests: b(
    ae(
      () => U([
        dt(Rr),
        dt($s)
      ])
    )
  )
}), wy = Ry.extend({
  folders: ae(() => b(ce(F, 1)))
}), Vc = _({
  initial: !0,
  schema: wy
}), _l = f({
  v: d(2),
  id: ie(c()),
  // For Firestore ID data
  name: c(),
  requests: b(
    ae(
      () => U([
        dt(Rr),
        dt($s)
      ])
    )
  ),
  auth: U([ku, ul]),
  headers: U([Tu, b(Ms)])
}), Cy = _l.extend({
  folders: ae(() => b(ce(F, 2)))
}), Iy = _({
  initial: !1,
  schema: Cy,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), bl = _l.extend({
  v: d(3),
  // AWS Signature Authorization type addition
  auth: U([Mu, fl]),
  // `description` field addition under `headers`
  headers: U([Ar, b(dl)])
}), xy = bl.extend({
  folders: ae(() => b(ce(F, 3)))
}), ky = _({
  initial: !1,
  schema: xy,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = F.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Sl = bl.extend({
  v: d(4),
  auth: U([Is, pl])
}), Oy = Sl.extend({
  folders: ae(() => b(ce(F, 4)))
}), qy = _({
  initial: !1,
  schema: Oy,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Al = Sl.extend({
  v: d(5),
  _ref_id: c().optional()
}), Py = Al.extend({
  folders: ae(() => b(ce(F, 5)))
}), Vy = _({
  initial: !1,
  schema: Py,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: qt("coll"),
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Tl = Al.extend({
  v: d(6),
  auth: U([xs, Cr])
}), My = Tl.extend({
  folders: ae(() => b(ce(F, 6)))
}), Ny = _({
  initial: !1,
  schema: My,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = F.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), El = Tl.extend({
  v: d(7),
  auth: U([Ps, Cr])
}), $y = El.extend({
  folders: ae(() => b(ce(F, 7)))
}), Dy = _({
  initial: !1,
  schema: $y,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Rl = El.extend({
  v: d(8),
  auth: U([Vs, Cr])
}), Hy = Rl.extend({
  folders: ae(() => b(ce(F, 8)))
}), jy = _({
  initial: !1,
  schema: Hy,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), wl = Rl.extend({
  v: d(9),
  auth: U([Er, vl])
}), Ly = wl.extend({
  folders: ae(() => b(ce(F, 9)))
}), Uy = _({
  initial: !1,
  schema: Ly,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const n = e.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, t = {
        ...e.auth,
        grantTypeInfo: a
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t,
      folders: e.folders.map((n) => {
        const a = F.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Ky = f({
  key: c(),
  initialValue: c(),
  currentValue: c(),
  secret: R()
}), Cl = wl.extend({
  v: d(10),
  variables: b(Ky)
}), By = Cl.extend({
  folders: ae(() => b(ce(F, 10)))
}), Gy = _({
  initial: !1,
  schema: By,
  up(e) {
    return {
      ...e,
      v: 10,
      variables: [],
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 10);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Il = Cl.extend({
  v: d(11),
  description: c().nullable().catch(null)
}), Fy = Il.extend({
  folders: ae(() => b(ce(F, 11)))
}), Zy = _({
  initial: !1,
  schema: Fy,
  up(e) {
    return {
      ...e,
      v: 11,
      description: null,
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 11);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Wy = Il.extend({
  v: d(12),
  preRequestScript: c().catch(""),
  testScript: c().catch("")
}), Jy = Wy.extend({
  folders: ae(() => b(ce(F, 12)))
}), zy = _({
  initial: !1,
  schema: Jy,
  up(e) {
    return {
      ...e,
      v: 12,
      preRequestScript: "",
      testScript: "",
      folders: e.folders.map((r) => {
        const n = F.safeParseUpToVersion(r, 12);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Qy = f({
  v: Ze()
}), F = We({
  latestVersion: 12,
  versionMap: {
    1: Vc,
    2: Iy,
    3: ky,
    4: qy,
    5: Vy,
    6: Ny,
    7: Dy,
    8: jy,
    9: Uy,
    10: Gy,
    11: Zy,
    12: zy
  },
  getVersion(e) {
    const t = Qy.safeParse(e);
    return t.success ? t.data.v : Vc.schema.safeParse(e).success ? 1 : null;
  }
}), Yy = 12;
function xl(e) {
  return {
    v: Yy,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : qt("coll")
  };
}
function Xy(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(Xy), n = (e.requests ?? []).map(sy), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = e.description ?? null, l = e.preRequestScript ?? "", u = e.testScript ?? "", h = xl({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i,
    description: o,
    preRequestScript: l,
    testScript: u
  });
  return e.id && (h.id = e.id), e._ref_id && (h._ref_id = e._ref_id), h;
}
function em(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(em), n = (e.requests ?? []).map(Ey), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = e.description ?? null, l = e.preRequestScript ?? "", u = e.testScript ?? "", h = xl({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i,
    description: o,
    preRequestScript: l,
    testScript: u
  });
  return e.id && (h.id = e.id), e._ref_id && (h._ref_id = e._ref_id), h;
}
var Me = function(e) {
  return function(t) {
    return !e(t);
  };
}, tm = zd, rm = Wd;
function kl(e, t) {
  return t === void 0 ? function(r) {
    return kl(e, r);
  } : rm(e, t) ? Zc : Wc(t[e]);
}
var Ol = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, nm = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      Fc(a) && r.push(a.value);
    }
    return r;
  };
}, am = function(e) {
  return nm(function(t, r) {
    return e(r);
  });
}, ql = function(e) {
  return e.slice();
}, sm = Zd, Mc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, im = function(e) {
  return function(t) {
    return Mc(Mc([], t, !0), [e], !1);
  };
}, om = im, cm = function(e) {
  return [e];
}, um = om, lm = kl, dm = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, fm = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, hm = function() {
  return {
    concat: fm().concat,
    empty: []
  };
}, Ir = Zc, Pt = Wc;
function Pl(e) {
  return function(t) {
    return e(t) ? Pt(t) : Ir;
  };
}
var as = function(e) {
  return function(t) {
    return Vl(t) ? Ir : Pt(e(t.value));
  };
}, pm = Fc, Vl = function(e) {
  return e._tag === "None";
}, ym = function(e, t) {
  return function(r) {
    return Vl(r) ? e() : t(r.value);
  };
}, mm = ym, Ds = mm, vm = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Ne = Dd, de = Hd, gm = /* @__PURE__ */ Pd(2, function(e, t) {
  return ft(e) ? e : t(e.right);
}), Vt = function(e) {
  return function(t) {
    return ft(t) ? t : de(e(t.right));
  };
}, xr = function(e) {
  return function(t) {
    return ft(t) ? Ne(e(t.left)) : t;
  };
}, ft = Nd, _m = $d, bm = function(e) {
  return function(t) {
    return ft(t) ? e(t.left) : t.right;
  };
}, Hs = bm, Nc = gm, ar = function() {
  return ar = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, ar.apply(this, arguments);
}, Mt = function(e, t, r) {
  return de({
    value: e,
    next: t,
    start: r
  });
}, Nt = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Ne({
    input: e,
    expected: t,
    fatal: r
  });
}, Sm = function(e, t) {
  return ar(ar({}, e), { expected: t });
}, Am = function(e, t) {
  return Tm().concat(e, t);
}, Tm = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Gd().concat(e, t) : e.input.cursor > t.input.cursor ? Pr().concat(e, t) : Bd({
        input: Pr(),
        fatal: Pr(),
        expected: hm()
      }).concat(e, t);
    }
  };
}, Em = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, Rm = function(e) {
  return lm(e.cursor, e.buffer);
}, wm = function(e) {
  return e.cursor >= e.buffer.length;
}, Cm = function(e) {
  return A(Rm(e), as(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, xe = function() {
  return xe = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, xe.apply(this, arguments);
}, js = function(e) {
  return function(t) {
    return Mt(e, t, t);
  };
}, Im = function() {
  return function(e) {
    return Nt(e);
  };
}, xm = function(e) {
  return function() {
    return Nt(e);
  };
}, Q = function(e) {
  return A(qm(km()), ze(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? ht(r) : xm(n);
  }));
}, z = function(e, t) {
  return function(r) {
    return A(e(r), xr(function(n) {
      return Sm(n, [t]);
    }));
  };
}, km = function() {
  return function(e) {
    return A(Cm(e), Ds(function() {
      return Nt(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return Mt(r, n, e);
    }));
  };
}, Om = function(e, t) {
  return function(r) {
    return A(e(r), Nc(function(n) {
      return A(t(n.value)(n.next), Nc(function(a) {
        return Mt(a.value, a.next, r);
      }));
    }));
  };
}, kr = function(e, t) {
  return function(r) {
    var n = e(r);
    return _m(n) || n.left.fatal ? n : A(t()(r), xr(function(a) {
      return Am(n.left, a);
    }));
  };
}, qm = function(e) {
  return function(t) {
    return A(e(t), Vt(function(r) {
      return xe(xe({}, r), { value: [r.value, t] });
    }));
  };
}, Ml = function(e) {
  return Qe(function() {
    return ht(e.empty);
  });
}, Ls = function() {
  return z(function(e) {
    return wm(e) ? Mt(void 0, e, e) : Nt(e);
  }, "end of file");
}, Pm = function(e) {
  return A(Us(e), Qe(function() {
    return ht([]);
  }));
}, Us = function(e) {
  return A(e, ze(function(t) {
    return Bs(cm(t), function(r) {
      return A(e, J(function(n) {
        return Ne(um(n)(r));
      }), Qe(function() {
        return ht(de(r));
      }));
    });
  }));
}, Vm = function(e, t) {
  return function(r) {
    return A(e, ze(function() {
      return r;
    }), Gs(function() {
      return t;
    }));
  };
}, Nl = function(e) {
  return Vm(e, e);
}, Mm = function(e) {
  return Pm(Q(Me(e)));
}, Ks = function(e, t) {
  return A(t, J(function() {
    return sm;
  }), Qe(function() {
    return Nm(e, t);
  }));
}, Nm = function(e, t) {
  return A(e, ze(function(r) {
    return Bs(Qd(r), function(n) {
      return A(t, J(function() {
        return de(n);
      }), Qe(function() {
        return A(e, J(function(a) {
          return Ne(tm(a)(n));
        }));
      }));
    });
  }));
}, $t = function(e, t) {
  return function(r) {
    return A(e(r), Vt(function(n) {
      return xe(xe({}, n), { value: t(n.value) });
    }));
  };
}, $l = function(e, t) {
  return Or(e, function(r) {
    return $t(t, r);
  });
}, Or = function(e, t) {
  return Om(e, t);
}, Bs = function(e, t) {
  var r = function(n) {
    return function(a) {
      return ft(a.value) ? Ne({ value: a.value.left, stream: a.next }) : de(Mt(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return vm({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return ft(s) ? de(Nt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, $m = function(e, t) {
  return kr(e, t);
}, J = function(e) {
  return function(t) {
    return $t(t, e);
  };
}, ht = js, ze = function(e) {
  return function(t) {
    return Or(t, e);
  };
}, Gs = function(e) {
  return function(t) {
    return Or(t, function(r) {
      return $t(e(r), function() {
        return r;
      });
    });
  };
}, Qe = function(e) {
  return function(t) {
    return $m(t, e);
  };
}, Dm = "Parser", Hm = function(e) {
  return {
    concat: function(t, r) {
      return $l($t(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, jm = function(e) {
  return xe(xe({}, Hm(e)), { empty: js(e.empty) });
}, Lm = {
  URI: Dm,
  map: $t,
  ap: $l,
  chain: Or,
  chainRec: Bs
}, Dl = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Hl = function(e) {
  return function(t) {
    return A(t, J(function(r) {
      return Dl({}, e, r);
    }));
  };
}, ss = function(e, t) {
  return function(r) {
    return A(r, ze(function(n) {
      return A(t(n), J(function(a) {
        return Dl(n, e, a);
      }));
    }));
  };
}, Um = function(e) {
  return Fd(e)(e.empty);
}, Km = Ml(us), pt = function(e) {
  return z(Q(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, Bm = function(e) {
  return z(Q(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Fs = function(e) {
  return Km(Dt(e));
}, Dt = function(e) {
  return A(Us(e), J(function(t) {
    return t.join("");
  }));
}, Zs = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, is = z(Q(Zs), "a digit"), Gm = /^\s$/, jl = function(e) {
  return Gm.test(e);
}, Ll = z(Q(jl), "a whitespace"), Fm = function(e) {
  return e === "_";
}, Ht = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Ul = function(e) {
  return Ht(e) || Zs(e) || Fm(e);
};
z(Q(Ul), "a word character");
z(Q(Ht), "a letter");
var Zm = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
z(Q(Zm), "an unicode letter");
var Kl = function(e) {
  return Ht(e) && e === e.toUpperCase();
};
z(Q(Kl), "an upper case letter");
var Bl = function(e) {
  return Ht(e) && e === e.toLowerCase();
};
z(Q(Bl), "a lower case letter");
z(Q(Me(Zs)), "a non-digit");
var Gl = z(Q(Me(jl)), "a non-whitespace character");
z(Q(Me(Ul)), "a non-word character");
z(Q(Me(Ht)), "a non-letter character");
z(Q(Me(Kl)), "anything but an upper case letter");
z(Q(Me(Bl)), "anything but a lower case letter");
var Fl = function(e) {
  return z(Lm.chainRec(e, function(t) {
    return A(zm(0, t), Ds(function() {
      return ht(de(e));
    }, function(r) {
      return A(pt(r), ze(function() {
        return ht(Ne(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, os = Um(jm(us)), xt = Ml(us), Wm = function(e) {
  return xt(Jm(e));
}, Jm = function(e) {
  return A(Us(e), J(function(t) {
    return t.join("");
  }));
}, zm = function(e, t) {
  return e >= 0 && e < t.length ? Pt(t.charAt(e)) : Ir;
}, Qm = Fs(Ll);
Dt(Ll);
Fs(Gl);
Dt(Gl);
var Ym = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? Ir : Pt(t);
};
z(A(os([xt(pt("-")), Dt(is)]), J(function(e) {
  return +e;
})), "an integer");
z(A(os([xt(pt("-")), Fs(is), xt(os([pt("."), Dt(is)]))]), ze(function(e) {
  return A(Ym(e), Ds(function() {
    return Im();
  }, js));
})), "a float");
var Xm = Nl(pt('"'))(Wm(kr(Fl('\\"'), function() {
  return Bm('"');
})));
function Zl(e) {
  return function(t) {
    return t(Em(e.split("")));
  };
}
const $c = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), ev = ["#", ":"], yt = Nl(Qm), Ws = (e) => (t) => t.join(e), Js = (e) => A(
  Mm((t) => e.includes(t)),
  J(Ws(""))
), tv = we(
  Js,
  Gs(() => Q(() => !0))
), Wl = A(
  Xm,
  J((e) => JSON.parse(`"${e}"`))
), rv = A(
  yt(Wl),
  Qe(
    () => A(
      Js([":", `
`]),
      J(Jc)
    )
  )
), nv = A(
  yt(Wl),
  Qe(
    () => A(
      Js([`
`]),
      J(Jc)
    )
  )
), Jl = A(
  xt(Fl("#")),
  J(Me(zc))
), zl = A(
  yt(Jl),
  Hl("commented"),
  ss("key", () => yt(rv)),
  Gs(() => pt(":")),
  ss("value", () => nv)
), av = A(
  yt(Jl),
  Hl("commented"),
  ss("key", () => kr(
    tv([`
`]),
    () => A(
      Ks(Q((e) => !0), Ls()),
      J(we(
        ql,
        Ws("")
      ))
    )
  )),
  J(we(
    Pl(({ key: e }) => !zc(e))
  ))
), sv = A(
  Ks(yt(zl), Ls())
), iv = A(
  Ks(
    kr(
      A(zl, J(Pt)),
      () => A(
        av,
        J(we(
          as((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Ls()
  ),
  J(we(
    am(we(
      Pl(pm),
      as((e) => e.value)
    ))
  ))
), ov = (e) => {
  if (ev.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Dc = (e) => ov(e) ? JSON.stringify(e) : e, yg = (e) => A(
  e,
  dm(
    we(
      $c("key", Dc),
      $c("value", Dc),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  Ws(`
`)
), cv = (e) => A(
  iv,
  Zl(e),
  xr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Vt(
    ({ value: t }) => A(
      t,
      Ol(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), mg = (e) => A(
  sv,
  Zl(e),
  xr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Vt(
    ({ value: t }) => A(
      t,
      Ol(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), vg = we(
  cv,
  Vt(ql),
  Hs(() => [])
), uv = f({
  id: ie(c()),
  name: c(),
  variables: b(
    f({
      key: c(),
      value: c()
    })
  )
}), Hc = _({
  initial: !0,
  schema: uv
}), Ql = () => Math.random().toString(36).substring(2, 16), Yl = f({
  v: d(1),
  id: c(),
  name: c(),
  variables: b(
    U([
      f({
        key: c(),
        secret: d(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: d(!1).catch(!1)
      })
    ])
  )
}), lv = _({
  initial: !1,
  schema: Yl,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || Ql(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), dv = Yl.extend({
  v: d(2),
  variables: b(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: R()
    })
  )
}), fv = _({
  initial: !1,
  schema: dv,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), jc = () => {
  const e = "0123456789abcdef";
  let t = "";
  for (let r = 0; r < 36; r++)
    r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(Math.floor(Math.random() * e.length));
  return t;
}, Xl = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: jc
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: jc
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16).padStart(4, "0")
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16).padStart(2, "0")
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Company names
  {
    key: "$randomCompanyName",
    description: "A random company name.",
    getValue: () => {
      const e = [
        "Nexora",
        "CodeLoom",
        "BitHaven",
        "SynapseWorks",
        "VoltEdge",
        "Elevoria",
        "Bridgent",
        "Verniq",
        "Corevia",
        "Stratigen",
        "Lunova Studio",
        "Pixelora",
        "MuseMind",
        "BrightNest",
        "Auralis",
        "VerdaFlow",
        "BloomShift",
        "PureTrek",
        "EcoVerse",
        "ReLeaf Labs"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], hv = f({
  v: Ze()
}), gg = We({
  latestVersion: 2,
  versionMap: {
    0: Hc,
    1: lv,
    2: fv
  },
  getVersion(e) {
    const t = hv.safeParse(e);
    return t.success ? t.data.v : Hc.schema.safeParse(e).success ? 0 : null;
  }
}), sr = /<<([^>]*)>>|\{\{([^}]*)\}\}/g, ir = 10, ed = "ENV_EXPAND_LOOP", Lc = 2;
function pv(e, t) {
  let r = e, n = 0;
  for (; r.match(sr) != null && n <= ir; )
    r = r.replace(sr, (a, s, i) => {
      const o = (s || i || "").trim(), l = Xl.find(
        (h) => h.key === o
      );
      if (l)
        return l.getValue();
      const u = t.find((h) => h.key === o);
      return u && "currentValue" in u ? u.currentValue : a;
    }), n++;
  return n > ir ? Ne(ed) : de(r);
}
const _g = (e, t) => A(
  pv(e, t),
  Hs(() => e)
);
function yv(e, t, r = !1, n = !1, a = !1) {
  if (!t || !e)
    return de(e);
  let s = e, i = 0, o = !1;
  for (; s.match(sr) != null && i <= ir && !o; ) {
    const l = decodeURI(encodeURI(s)).replace(
      sr,
      (u, h, m) => {
        const S = (h || m || "").trim(), P = Xl.find(
          (V) => V.key === S
        );
        if (P)
          return P.getValue();
        const N = t.find((V) => V && V.key === S);
        return N && "currentValue" in N ? N.secret && n ? (o = !0, h ? `<<${S}>>` : `{{${S}}}`) : N.secret && r ? "*".repeat(
          N.currentValue.length
        ) : N.currentValue : a ? h ? `<<${S}>>` : `{{${S}}}` : "";
      }
    );
    if (l === s)
      break;
    s = l, i++;
  }
  return i > ir ? Ne(ed) : de(s);
}
const bg = (e, t, r = !1, n = !1, a = !1) => A(
  yv(
    e,
    t,
    r,
    n,
    a
  ),
  Hs(() => e)
), mv = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), Sg = (e) => {
  if (e.v && e.v === Lc) return e;
  const t = e.id || Ql(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(mv);
  return {
    v: Lc,
    id: t,
    name: r,
    variables: n
  };
}, vv = b(
  U([
    f({
      key: c(),
      value: c(),
      secret: d(!1)
    }),
    f({
      key: c(),
      secret: d(!0)
    }),
    f({
      key: c(),
      value: c()
    })
  ])
), Uc = _({
  initial: !0,
  schema: vv
}), td = f({
  v: d(1),
  variables: b(
    U([
      f({
        key: c(),
        secret: d(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: d(!1)
      })
    ])
  )
}), gv = _({
  initial: !1,
  schema: td,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), _v = td.extend({
  v: d(2),
  variables: b(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: R()
    })
  )
}), bv = _({
  initial: !1,
  schema: _v,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), Sv = f({
  v: Ze()
}), Ag = We({
  latestVersion: 2,
  versionMap: {
    0: Uc,
    1: gv,
    2: bv
  },
  getVersion(e) {
    const t = Sv.safeParse(e);
    return t.success ? t.data.v : Uc.schema.safeParse(e).success ? 0 : null;
  }
});
async function Av(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function Tv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function Ev(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function Rv(e, t) {
  return t === "sha256" ? Tv(e) : Ev(e);
}
async function wv(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), l = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(l)]));
}
function nt(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function Cv(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), nt(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), nt(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return nt(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return nt(JSON.stringify(r));
    } catch {
      return nt(e.toString());
    }
  return nt(e.toString());
}
async function Tg(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await Av(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const m = e.contentType || "text/plain", S = await Cv(e.payload, m), P = `hawk.1.payload
${m}
${S}
`, N = await Rv(P, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(N)])
      );
    } catch (m) {
      console.error("Error calculating payload hash:", m);
    }
  const l = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, u = await wv(e.key, l, e.algorithm), h = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${u}"`
  ];
  return e.ext && e.ext !== "" && h.push(`ext="${e.ext}"`), e.app && e.app !== "" && h.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && h.push(`dlg="${e.dlg}"`), o.hash !== "" && h.push(`hash="${o.hash}"`), h.join(", ");
}
async function Eg(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const m = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(m)).map((S) => S.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, l = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), u = btoa(
    String.fromCharCode(...new Uint8Array(l))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${u}`;
}
const rd = new TextEncoder(), Kc = new TextDecoder();
function Iv(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function Wa(e) {
  const t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n > 127)
      throw new TypeError("non-ASCII string encountered in encode()");
    t[r] = n;
  }
  return t;
}
function xv(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function kv(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function Ov(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : Kc.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = Kc.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return kv(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function Ja(e) {
  let t = e;
  return typeof t == "string" && (t = rd.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : xv(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
const Ee = (e, t = "algorithm.name") => new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`), at = (e, t) => e.name === t;
function qv(e) {
  return parseInt(e.name.slice(4), 10);
}
function za(e, t) {
  if (qv(e.hash) !== t)
    throw Ee(`SHA-${t}`, "algorithm.hash");
}
function Pv(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function Vv(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function Mv(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!at(e.algorithm, "HMAC"))
        throw Ee("HMAC");
      za(e.algorithm, parseInt(t.slice(2), 10));
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!at(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw Ee("RSASSA-PKCS1-v1_5");
      za(e.algorithm, parseInt(t.slice(2), 10));
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!at(e.algorithm, "RSA-PSS"))
        throw Ee("RSA-PSS");
      za(e.algorithm, parseInt(t.slice(2), 10));
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!at(e.algorithm, "Ed25519"))
        throw Ee("Ed25519");
      break;
    }
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87": {
      if (!at(e.algorithm, t))
        throw Ee(t);
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!at(e.algorithm, "ECDSA"))
        throw Ee("ECDSA");
      const n = Pv(t);
      if (e.algorithm.namedCurve !== n)
        throw Ee(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  Vv(e, r);
}
function nd(e, t, ...r) {
  if (r = r.filter(Boolean), r.length > 2) {
    const n = r.pop();
    e += `one of type ${r.join(", ")}, or ${n}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && t.constructor?.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const Nv = (e, ...t) => nd("Key must be ", e, ...t), ad = (e, t, ...r) => nd(`Key for the ${e} algorithm must be `, t, ...r);
class zs extends Error {
  static code = "ERR_JOSE_GENERIC";
  code = "ERR_JOSE_GENERIC";
  constructor(t, r) {
    super(t, r), this.name = this.constructor.name, Error.captureStackTrace?.(this, this.constructor);
  }
}
class Le extends zs {
  static code = "ERR_JOSE_NOT_SUPPORTED";
  code = "ERR_JOSE_NOT_SUPPORTED";
}
class _t extends zs {
  static code = "ERR_JWS_INVALID";
  code = "ERR_JWS_INVALID";
}
class $v extends zs {
  static code = "ERR_JWT_INVALID";
  code = "ERR_JWT_INVALID";
}
const sd = (e) => {
  if (e?.[Symbol.toStringTag] === "CryptoKey")
    return !0;
  try {
    return e instanceof CryptoKey;
  } catch {
    return !1;
  }
}, id = (e) => e?.[Symbol.toStringTag] === "KeyObject", od = (e) => sd(e) || id(e);
function Bc(e, t) {
  if (e)
    throw new TypeError(`${t} can only be called once`);
}
const Dv = (e) => typeof e == "object" && e !== null;
function cd(e) {
  if (!Dv(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Hv(...e) {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
}
const Qs = (e) => cd(e) && typeof e.kty == "string", jv = (e) => e.kty !== "oct" && (e.kty === "AKP" && typeof e.priv == "string" || typeof e.d == "string"), Lv = (e) => e.kty !== "oct" && e.d === void 0 && e.priv === void 0, Uv = (e) => e.kty === "oct" && typeof e.k == "string";
function Kv(e, t) {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
}
function Bv(e, t) {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      return { name: e };
    default:
      throw new Le(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}
async function Gv(e, t, r) {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(Nv(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return Mv(t, e, r), t;
}
async function Fv(e, t, r) {
  const n = await Gv(e, t, "sign");
  Kv(e, n);
  const a = await crypto.subtle.sign(Bv(e, n.algorithm), n, r);
  return new Uint8Array(a);
}
const Gt = 'Invalid or unsupported JWK "alg" (Algorithm) Parameter value';
function Zv(e) {
  let t, r;
  switch (e.kty) {
    case "AKP": {
      switch (e.alg) {
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
          t = { name: e.alg }, r = e.priv ? ["sign"] : ["verify"];
          break;
        default:
          throw new Le(Gt);
      }
      break;
    }
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Le(Gt);
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
        case "ES384":
        case "ES512":
          t = {
            name: "ECDSA",
            namedCurve: { ES256: "P-256", ES384: "P-384", ES512: "P-521" }[e.alg]
          }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Le(Gt);
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Le(Gt);
      }
      break;
    }
    default:
      throw new Le('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
async function Wv(e) {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = Zv(e), n = { ...e };
  return n.kty !== "AKP" && delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !(e.d || e.priv), e.key_ops ?? r);
}
const st = "given KeyObject instance cannot be used for this algorithm";
let ct;
const Gc = async (e, t, r, n = !1) => {
  ct ||= /* @__PURE__ */ new WeakMap();
  let a = ct.get(e);
  if (a?.[r])
    return a[r];
  const s = await Wv({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : ct.set(e, { [r]: s }), s;
}, Jv = (e, t) => {
  ct ||= /* @__PURE__ */ new WeakMap();
  let r = ct.get(e);
  if (r?.[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError(st);
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError(st);
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  switch (e.asymmetricKeyType) {
    case "ml-dsa-44":
    case "ml-dsa-65":
    case "ml-dsa-87": {
      if (t !== e.asymmetricKeyType.toUpperCase())
        throw new TypeError(st);
      s = e.toCryptoKey(e.asymmetricKeyType, a, [
        n ? "verify" : "sign"
      ]);
    }
  }
  if (e.asymmetricKeyType === "rsa") {
    let i;
    switch (t) {
      case "RSA-OAEP":
        i = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        i = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        i = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        i = "SHA-512";
        break;
      default:
        throw new TypeError(st);
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: i
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: i
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const o = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get(e.asymmetricKeyDetails?.namedCurve);
    if (!o)
      throw new TypeError(st);
    const l = { ES256: "P-256", ES384: "P-384", ES512: "P-521" };
    l[t] && o === l[t] && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: o
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: o
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError(st);
  return r ? r[t] = s : ct.set(e, { [t]: s }), s;
};
async function zv(e, t) {
  if (e instanceof Uint8Array || sd(e))
    return e;
  if (id(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return Jv(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return Gc(e, r, t);
  }
  if (Qs(e))
    return e.k ? Ov(e.k) : Gc(e, e, t, !0);
  throw new Error("unreachable");
}
function Qv(e, t, r, n, a) {
  if (a.crit !== void 0 && n?.crit === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Le(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
}
const ot = (e) => e?.[Symbol.toStringTag], cs = (e, t, r) => {
  if (t.use !== void 0) {
    let n;
    switch (r) {
      case "sign":
      case "verify":
        n = "sig";
        break;
      case "encrypt":
      case "decrypt":
        n = "enc";
        break;
    }
    if (t.use !== n)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${n}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let n;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        n = r;
        break;
      case e.startsWith("PBES2"):
        n = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? n = "unwrapKey" : n = r;
        break;
      case r === "encrypt":
        n = "wrapKey";
        break;
      case r === "decrypt":
        n = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (n && t.key_ops?.includes?.(n) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${n}" when present`);
  }
  return !0;
}, Yv = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (Qs(t)) {
      if (Uv(t) && cs(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!od(t))
      throw new TypeError(ad(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${ot(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, Xv = (e, t, r) => {
  if (Qs(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (jv(t) && cs(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation must be a private JWK");
      case "encrypt":
      case "verify":
        if (Lv(t) && cs(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation must be a public JWK");
    }
  if (!od(t))
    throw new TypeError(ad(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${ot(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${ot(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${ot(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${ot(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${ot(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
};
function eg(e, t, r) {
  switch (e.substring(0, 2)) {
    case "A1":
    case "A2":
    case "di":
    case "HS":
    case "PB":
      Yv(e, t, r);
      break;
    default:
      Xv(e, t, r);
  }
}
const He = (e) => Math.floor(e.getTime() / 1e3), ud = 60, ld = ud * 60, Ys = ld * 24, tg = Ys * 7, rg = Ys * 365.25, ng = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function Qa(e) {
  const t = ng.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * ud);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * ld);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * Ys);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * tg);
      break;
    default:
      a = Math.round(r * rg);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
}
function je(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
class ag {
  #e;
  constructor(t) {
    if (!cd(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    this.#e = structuredClone(t);
  }
  data() {
    return rd.encode(JSON.stringify(this.#e));
  }
  get iss() {
    return this.#e.iss;
  }
  set iss(t) {
    this.#e.iss = t;
  }
  get sub() {
    return this.#e.sub;
  }
  set sub(t) {
    this.#e.sub = t;
  }
  get aud() {
    return this.#e.aud;
  }
  set aud(t) {
    this.#e.aud = t;
  }
  set jti(t) {
    this.#e.jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? this.#e.nbf = je("setNotBefore", t) : t instanceof Date ? this.#e.nbf = je("setNotBefore", He(t)) : this.#e.nbf = He(/* @__PURE__ */ new Date()) + Qa(t);
  }
  set exp(t) {
    typeof t == "number" ? this.#e.exp = je("setExpirationTime", t) : t instanceof Date ? this.#e.exp = je("setExpirationTime", He(t)) : this.#e.exp = He(/* @__PURE__ */ new Date()) + Qa(t);
  }
  set iat(t) {
    t === void 0 ? this.#e.iat = He(/* @__PURE__ */ new Date()) : t instanceof Date ? this.#e.iat = je("setIssuedAt", He(t)) : typeof t == "string" ? this.#e.iat = je("setIssuedAt", He(/* @__PURE__ */ new Date()) + Qa(t)) : this.#e.iat = je("setIssuedAt", t);
  }
}
class sg {
  #e;
  #t;
  #r;
  constructor(t) {
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    this.#e = t;
  }
  setProtectedHeader(t) {
    return Bc(this.#t, "setProtectedHeader"), this.#t = t, this;
  }
  setUnprotectedHeader(t) {
    return Bc(this.#r, "setUnprotectedHeader"), this.#r = t, this;
  }
  async sign(t, r) {
    if (!this.#t && !this.#r)
      throw new _t("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!Hv(this.#t, this.#r))
      throw new _t("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...this.#t,
      ...this.#r
    }, a = Qv(_t, /* @__PURE__ */ new Map([["b64", !0]]), r?.crit, this.#t, n);
    let s = !0;
    if (a.has("b64") && (s = this.#t.b64, typeof s != "boolean"))
      throw new _t('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new _t('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    eg(i, t, "sign");
    let o, l;
    s ? (o = Ja(this.#e), l = Wa(o)) : (l = this.#e, o = "");
    let u, h;
    this.#t ? (u = Ja(JSON.stringify(this.#t)), h = Wa(u)) : (u = "", h = new Uint8Array());
    const m = Iv(h, Wa("."), l), S = await zv(t, i), P = await Fv(i, S, m), N = {
      signature: Ja(P),
      payload: o
    };
    return this.#r && (N.header = this.#r), this.#t && (N.protected = u), N;
  }
}
class ig {
  #e;
  constructor(t) {
    this.#e = new sg(t);
  }
  setProtectedHeader(t) {
    return this.#e.setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await this.#e.sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
class og {
  #e;
  #t;
  constructor(t = {}) {
    this.#t = new ag(t);
  }
  setIssuer(t) {
    return this.#t.iss = t, this;
  }
  setSubject(t) {
    return this.#t.sub = t, this;
  }
  setAudience(t) {
    return this.#t.aud = t, this;
  }
  setJti(t) {
    return this.#t.jti = t, this;
  }
  setNotBefore(t) {
    return this.#t.nbf = t, this;
  }
  setExpirationTime(t) {
    return this.#t.exp = t, this;
  }
  setIssuedAt(t) {
    return this.#t.iat = t, this;
  }
  setProtectedHeader(t) {
    return this.#e = t, this;
  }
  async sign(t, r) {
    const n = new ig(this.#t.data());
    if (n.setProtectedHeader(this.#e), Array.isArray(this.#e?.crit) && this.#e.crit.includes("b64") && this.#e.b64 === !1)
      throw new $v("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
async function Rg(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, l = {};
  try {
    const u = a?.trim() || "{}";
    u === "" ? o = {} : o = JSON.parse(u);
  } catch (u) {
    return console.error("Failed to parse JWT payload JSON:", u), console.error("Payload value:", a), null;
  }
  try {
    const u = s?.trim() || "{}";
    u === "" ? l = {} : l = JSON.parse(u);
  } catch (u) {
    return console.error("Failed to parse JWT headers JSON:", u), console.error("Headers value:", s), null;
  }
  try {
    let u;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      u = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      u = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new og(o).setProtectedHeader({
      alg: t,
      ...l
    }).sign(u);
  } catch (u) {
    return console.error("Error generating JWT token:", u), null;
  }
}
const wg = f({
  name: c(),
  // Cookie name
  value: c(),
  // Cookie value
  domain: c(),
  // Domain the cookie belongs to
  path: c(),
  // Path scope of the cookie (default: "/")
  expires: c().optional(),
  // Expiration date in ISO format, null for session cookies
  maxAge: Ze().optional(),
  // Maximum age in seconds, null if not set
  httpOnly: R(),
  // Whether cookie is HTTP-only (not accessible via JavaScript)
  secure: R(),
  // Whether cookie should only be sent over HTTPS
  sameSite: ee(["None", "Lax", "Strict"])
  // SameSite attribute for CSRF protection
});
export {
  Tp as AuthCodeGrantTypeParams,
  Ep as ClientCredentialsGrantTypeParams,
  Yy as CollectionSchemaVersion,
  Ky as CollectionVariable,
  wg as CookieSchema,
  gg as Environment,
  Lc as EnvironmentSchemaVersion,
  Hu as FormDataKeyValue,
  dl as GQLHeader,
  gl as GQL_REQ_SCHEMA_VERSION,
  Ag as GlobalEnvironment,
  Xl as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  F as HoppCollection,
  vl as HoppGQLAuth,
  gt as HoppGQLAuthAPIKey,
  wr as HoppGQLAuthAWSSignature,
  qe as HoppGQLAuthBasic,
  Pe as HoppGQLAuthBearer,
  Ve as HoppGQLAuthInherit,
  Oe as HoppGQLAuthNone,
  Wu as HoppGQLAuthOAuth2,
  $s as HoppGQLRequest,
  Er as HoppRESTAuth,
  ke as HoppRESTAuthAPIKey,
  Je as HoppRESTAuthAWSSignature,
  qs as HoppRESTAuthAkamaiEdgeGrid,
  pe as HoppRESTAuthBasic,
  ye as HoppRESTAuthBearer,
  Ot as HoppRESTAuthDigest,
  Os as HoppRESTAuthHAWK,
  me as HoppRESTAuthInherit,
  Gu as HoppRESTAuthJWT,
  he as HoppRESTAuthNone,
  Wu as HoppRESTAuthOAuth2,
  Ar as HoppRESTHeaders,
  ws as HoppRESTParams,
  ks as HoppRESTReqBody,
  Rr as HoppRESTRequest,
  $p as HoppRESTRequestResponse,
  Ju as HoppRESTRequestResponses,
  Rs as HoppRESTRequestVariables,
  kp as HoppRESTResponseOriginalRequest,
  wp as ImplicitOauthFlowParams,
  Ie as OAuth2AdvancedParam,
  Zu as OAuth2AuthRequestParam,
  Rp as PasswordGrantTypeParams,
  sl as RESTReqSchemaVersion,
  ug as ValidContentTypesList,
  Eg as calculateAkamaiEdgeGridHeader,
  Tg as calculateHawkHeader,
  Rg as generateJWTToken,
  qt as generateUniqueRefId,
  Ty as getDefaultGQLRequest,
  ay as getDefaultRESTRequest,
  lg as isEqualHoppRESTRequest,
  hg as isHoppRESTRequest,
  ty as knownContentTypes,
  xl as makeCollection,
  pg as makeGQLRequest,
  cg as makeHoppRESTResponseOriginalRequest,
  fg as makeRESTRequest,
  _g as parseBodyEnvVariables,
  pv as parseBodyEnvVariablesE,
  vg as parseRawKeyValueEntries,
  cv as parseRawKeyValueEntriesE,
  bg as parseTemplateString,
  yv as parseTemplateStringE,
  yg as rawKeyValueEntriesToString,
  dg as safelyExtractRESTRequest,
  mg as strictParseRawKeyValueEntriesE,
  Ey as translateToGQLRequest,
  Sg as translateToNewEnvironment,
  mv as translateToNewEnvironmentVariables,
  em as translateToNewGQLCollection,
  Xy as translateToNewRESTCollection,
  sy as translateToNewRequest
};
